(function(){
"use strict";
window.PRE_TRIP_IQ_MISSION_BUILD="V12_DEMO_FIRST_VOICE_TO_INSPECTION";
var root=document.querySelector("[data-ptiq-mission-root]");if(!root){return;}
var URLS={study:"/pages/cdl-pre-trip-study-guide",inspection:"/pages/inspection-iq",voice:"/pages/voice-practice-iq",parts:"/pages/parts-iq",practice:"/pages/practice-tests",dashboard:"/pages/cdl-curriculum-overview"};
var PTIQ_PROGRESS_VERSION="guided_coach_v4";
var MISSIONS={
1:{week:"WEEK 1 · FOUNDATION",title:"Welcome to the CDL Pre-Trip",summary:"Understand what the inspection is, how the training journey works, and the four major areas you will learn over the next 21 days.",time:"20–25 minutes",focus:"Build your foundation",coach:"Today is about understanding the map, not memorizing the whole truck. Accuracy will come one mission at a time.",steps:[
{id:"welcome",label:"Mission Brief",desc:"Understand today's goal.",type:"brief",heading:"Start with a clear plan.",body:"You do not need to know the entire truck today. Day 1 gives you the map. Over the next 21 missions, you will learn the parts, practice the inspection out loud, apply the sequence, and test your readiness.",note:"Understand the purpose of the inspection and the training path before memorizing individual components."},
{id:"learn",label:"Learn the Test",desc:"Build the right mental model.",type:"cards",heading:"What the pre-trip is really testing.",body:"You are demonstrating that you can identify safety-related components, describe what you are checking, recognize unsafe conditions, and follow a repeatable sequence.",cards:[["Identify","Name or locate the component."],["Inspect","State the condition, security, damage, leakage, or wear you are checking."],["Explain","Connect the check to safe vehicle operation."],["Stay in Order","Use a consistent sequence so important items are not skipped."]]},
{id:"visual",label:"Meet the Truck",desc:"Learn the four major areas.",type:"components",heading:"Build your four-part mental map.",body:"You will revisit these areas throughout the program.",components:[["Engine Compartment","Steering, suspension, brakes, fluids, belts, hoses, and visible safety components."],["Driver-Side Walkaround","Wheels, tires, lights, doors, fuel area, frame, axles, and external condition."],["Coupling & Trailer","Connections, locking devices, airlines, electrical line, landing gear, and trailer structure."],["In-Cab & Air Brakes","Controls, gauges, safety equipment, warning devices, and air-brake checks."]]},
{id:"voice",label:"Voice Introduction",desc:"Practice one low-pressure line.",type:"voice",heading:"Practice speaking without pressure.",body:"Read the short line below. This attempt does not affect your readiness score.",prompt:"I will inspect this vehicle in a consistent order and identify any condition that could make it unsafe to operate."},
{id:"quiz",label:"Knowledge Check",desc:"Prove today's foundation.",type:"quiz",heading:"Finish Day 1 with five quick questions.",questions:[
["What is the main purpose of a pre-trip inspection?",["Make the vehicle look clean","Identify unsafe conditions before operating","Estimate fuel mileage"],1,"Safety comes first: identify unsafe conditions before operating."],
["Why use a consistent inspection order?",["Prevent skipped items","Make the truck run faster","Replace the official manual"],0,"A repeatable order reduces omissions."],
["Which is a major training area?",["Engine Compartment","Dispatch Scheduling","Freight Pricing"],0,"The engine compartment is one of the four major areas."],
["What should your spoken inspection communicate?",["Only the part name","What you check and why it matters","Your driving history"],1,"A strong inspection explains the check and its safety importance."],
["Best source for exact state procedures?",["Random social post","Current official CDL manual and verified local procedures","Vehicle advertisement"],1,"Always compare with official and verified local requirements."]]}],reward:{knowledge:5,confidence:3,safety:3,next:"Engine Compartment"}},
2:{week:"WEEK 1 · FOUNDATION",title:"Engine Compartment",summary:"Learn the major engine-compartment systems, what to inspect, and how to describe safe condition and security.",time:"25–30 minutes",focus:"Recognize and inspect core systems",coach:"Work from top to bottom and side to side. A repeatable pattern helps you avoid skipping parts.",rewardPreview:"Knowledge +7 · Parts IQ +6 · Voice Confidence +4 · Safety +5",launchTip:"Do not memorize random parts. Learn one repeatable inspection flow: identify it, inspect condition and security, then explain why it matters.",steps:[
{id:"welcome",label:"Mission Brief",desc:"Set today's inspection target.",type:"brief",heading:"Build your engine-compartment routine.",body:"Today you will learn the visible components commonly inspected with the hood open. Focus on identifying the part, checking condition and security, and noticing leaks, wear, looseness, or damage.",note:"Use the same physical order every time so the sequence becomes automatic."},
{id:"learn",label:"Core Systems",desc:"Understand fluids, belts, and hoses.",type:"cards",heading:"Start with the systems that keep the truck operating.",body:"Exact layouts vary by truck, but the inspection logic remains consistent.",cards:[["Fluids","Check levels where applicable and look for visible leaks."],["Hoses","Check for cuts, cracks, bulges, abrasion, leaks, and secure connections."],["Belts","Check for excessive wear, fraying, cracks, looseness, and proper tension."],["Mounted Parts","Check that components and brackets are secure and not damaged."]]},
{id:"visual",label:"Find the Components",desc:"Build component recognition.",type:"components",heading:"Know what you are looking for.",body:"Use these groups as your visual checklist. Open Parts IQ or the Study Guide for deeper reference images as your library grows.",components:[["Coolant Reservoir","Secure, not leaking, and at an acceptable level where visible.","Stores coolant for temperature control.","Leaks, cracks, loose cap, low visible level.","Say both security and leakage."],["Engine Oil","Check the dipstick according to proper procedure and look for leakage.","Lubricates internal engine components.","Low level, contamination, visible leakage.","Follow the truck and state procedure before reading the dipstick."],["Power Steering Reservoir","Secure, properly filled where visible, and not leaking.","Supplies hydraulic fluid to steering assist.","Leaks, damaged hoses, loose mounting, low level.","Connect this check to safe steering control."],["Water Pump","Secure and not leaking; inspect belt or gear drive as applicable.","Circulates coolant through the engine.","Coolant leakage, loose mounting, damaged drive.","Identify whether the installed pump is belt or gear driven."],["Alternator","Secure, wiring intact, and belt condition/tension acceptable where belt driven.","Charges the electrical system while the engine runs.","Loose mounting, damaged wiring, worn or loose belt.","Mention mounting, wiring, and belt condition."],["Air Compressor","Secure, lines intact, and belt/gear drive condition as applicable.","Builds air pressure for the brake system.","Leaks, damaged lines, loose mounting, damaged drive.","Treat it as safety-critical because it supports air brakes."],["Belts & Hoses","No cuts, cracks, fraying, bulges, leaks, or excessive looseness.","Transfers power and carries fluids or air.","Fraying, cracking, rubbing, bulges, leakage, loose connections.","Use specific defect words instead of saying only good condition."],["Wiring","Secure, properly insulated, and free of exposed or damaged conductors.","Carries electrical power and signals.","Exposed conductors, loose routing, burns, corrosion, damaged insulation.","Look for both damage and secure routing."]]},
{id:"parts",label:"Interactive Parts IQ",desc:"Identify parts and choose the correct checks.",type:"partsChallenge",heading:"Train your eyes and inspection judgment.",body:"Work through eight engine-compartment challenges. Identify the component from the clue, then choose the inspection points that belong with it.",challenges:[
{name:"Coolant Reservoir",clue:"This translucent or visible-level container supports engine temperature control.",choices:["Coolant Reservoir","Air Compressor","Alternator","Steering Gearbox"],correct:0,checks:["Secure mounting","No visible leaks","Acceptable level where visible","Tire tread depth"],required:[0,1,2],coach:"Connect the reservoir to cooling: secure, no leaks, and proper visible level."},
{name:"Engine Oil Dipstick",clue:"This removable indicator is used according to proper procedure to verify engine oil level.",choices:["Power Steering Reservoir","Engine Oil Dipstick","Water Pump","Battery"],correct:1,checks:["Follow proper level-check procedure","Look for contamination or abnormal condition","Check for visible leakage","Inspect air-brake pushrod travel"],required:[0,1,2],coach:"The dipstick check is about proper procedure, oil condition, level, and leakage."},
{name:"Power Steering Reservoir",clue:"This reservoir supplies hydraulic fluid to assist vehicle steering.",choices:["Coolant Reservoir","Power Steering Reservoir","Air Compressor","Alternator"],correct:1,checks:["Secure mounting","Proper level where visible","No leaks or damaged hoses","Brake lining thickness"],required:[0,1,2],coach:"Always connect this component to steering control: secure, properly filled, and leak-free."},
{name:"Water Pump",clue:"This component circulates coolant through the engine and may be belt- or gear-driven.",choices:["Water Pump","Alternator","Steering Shaft","Battery"],correct:0,checks:["Secure mounting","No coolant leakage","Drive condition as applicable","Lug nuts present"],required:[0,1,2],coach:"Name the installed drive type and check mounting and coolant leakage."},
{name:"Alternator",clue:"This component charges the electrical system while the engine is running.",choices:["Air Compressor","Alternator","Water Pump","Coolant Reservoir"],correct:1,checks:["Secure mounting","Wiring intact","Belt condition and tension where applicable","No oil on brake lining"],required:[0,1,2],coach:"A complete alternator inspection covers mounting, wiring, and the drive belt when installed."},
{name:"Air Compressor",clue:"This safety-critical component builds air pressure for the brake system.",choices:["Alternator","Air Compressor","Power Steering Reservoir","Engine Oil Dipstick"],correct:1,checks:["Secure mounting","Lines intact and not leaking","Drive condition as applicable","Windshield cleanliness"],required:[0,1,2],coach:"Because it supports air brakes, verify mounting, lines, leakage, and drive condition."},
{name:"Belts and Hoses",clue:"These flexible components transfer power or carry fluids and air around the engine compartment.",choices:["Wiring only","Belts and Hoses","Steering Gearbox","Battery Terminals"],correct:1,checks:["No cuts, cracks, fraying, or bulges","No leaks or rubbing","Secure connections and proper tension where applicable","Trailer door latch operation"],required:[0,1,2],coach:"Use specific defect language: cuts, cracks, fraying, bulges, rubbing, leaks, security, and tension."},
{name:"Wiring",clue:"These insulated conductors carry electrical power and signals between engine-compartment systems.",choices:["Wiring","Coolant Hose","Drag Link","Leaf Spring"],correct:0,checks:["Secure routing","Insulation intact","No exposed conductors, burns, or corrosion","Tire inflation by appearance only"],required:[0,1,2],coach:"Inspect both condition and routing: secure, insulated, and free of exposed or damaged conductors."}
]},
{id:"voice",label:"Engine Voice Drill",desc:"Say the inspection clearly.",type:"voice",heading:"Practice a complete inspection phrase.",body:"Speak slowly and cover condition, security, and leakage.",prompt:"The engine-compartment components are securely mounted, not damaged, and show no visible leaks. Belts and hoses are in good condition and properly secured."},
{id:"quiz",label:"Knowledge Check",desc:"Prove engine-compartment knowledge.",type:"quiz",heading:"Check your engine-compartment foundation.",questions:[
["What should you check on hoses?",["Color only","Cuts, cracks, bulges, abrasion, leaks, and secure connections","Vehicle mileage"],1,"Hoses must be inspected for damage, leakage, and secure connections."],
["A belt should be checked for which condition?",["Fraying, cracks, wear, looseness, and tension","Paint color","Fuel grade"],0,"Belt condition and tension are essential checks."],
["What is a common mounted-component check?",["Secure and not damaged","Recently washed","Same brand as the truck"],0,"Mounted components should be secure and free of damage."],
["Why use a repeatable engine-compartment order?",["To avoid skipping components","To make the hood lighter","To replace hands-on practice"],0,"A repeatable pattern reduces missed items."],
["What should visible fluid areas be checked for?",["Leaks and acceptable level where applicable","Radio signal","Tire tread"],0,"Look for leaks and verify levels where the procedure permits."]]}],reward:{knowledge:7,confidence:4,safety:5,next:"Steering System"}},
3:{week:"WEEK 1 · FOUNDATION",title:"Steering System",summary:"Identify the major steering components and practice the condition, security, and free-play checks that protect vehicle control.",time:"22–28 minutes",focus:"Master steering component checks",coach:"Steering is safety-critical. Name each component, confirm it is secure, and look closely for looseness, damage, leakage, or missing hardware.",steps:[
{id:"welcome",label:"Mission Brief",desc:"Understand steering safety.",type:"brief",heading:"Protect control of the vehicle.",body:"The steering system transfers driver input to the wheels. A loose, damaged, leaking, or improperly secured steering component can affect control of the vehicle.",note:"Treat missed steering defects as safety-critical and review them before moving on."},
{id:"learn",label:"Steering Logic",desc:"Learn the inspection pattern.",type:"cards",heading:"Use four steering checks.",body:"Apply these checks to every visible steering component.",cards:[["Secure","Mounting bolts, brackets, and hardware should be present and tight."],["Not Damaged","Look for cracks, bends, breaks, or excessive wear."],["No Leaks","Check the steering gearbox, hoses, and connections for leakage."],["No Excessive Play","Linkage joints and the steering wheel should not have excessive free play."]]},
{id:"visual",label:"Steering Parts",desc:"Recognize the steering train.",type:"components",heading:"Follow steering movement from the wheel to the tires.",body:"Truck designs vary, but these common parts form the core steering linkage.",components:[["Steering Shaft","Secure, not bent or damaged, with joints in good condition."],["Steering Gearbox","Securely mounted, not leaking, and not damaged."],["Pitman Arm","Secure to the gearbox and not cracked, bent, or loose."],["Drag Link","Not bent or damaged; joints and hardware secure."],["Steering Knuckle","Secure and free of damage or excessive looseness."],["Tie Rod","Straight, secure, and joints free of excessive play."],["Hoses & Lines","Not cut, cracked, worn, leaking, or rubbing."],["Mounting Hardware","Present, tight, and without missing nuts, bolts, or cotter keys where required."]]},
{id:"voice",label:"Steering Voice Drill",desc:"Describe the system aloud.",type:"voice",heading:"Speak the steering inspection.",body:"Cover security, damage, leakage, and looseness.",prompt:"The steering gearbox is securely mounted and not leaking. The steering shaft, pitman arm, drag link, tie rod, and connecting hardware are secure, not damaged, and show no excessive looseness."},
{id:"quiz",label:"Safety Check",desc:"Prove steering knowledge.",type:"quiz",heading:"Complete the steering safety check.",questions:[
["What should be checked at the steering gearbox?",["Mounting, damage, and leaks","Cargo weight only","Paint finish"],0,"Gearbox security and leakage are critical."],
["What connects the gearbox movement into the steering linkage?",["Pitman arm","Mud flap","Landing gear"],0,"The pitman arm transfers movement from the gearbox."],
["What is a danger sign at linkage joints?",["Excessive play or looseness","Clean grease","Matching paint"],0,"Excessive play can reduce steering control."],
["What hardware issue should be reported?",["Missing or loose nuts, bolts, or required retainers","A new washer","A clean bracket"],0,"Missing or loose hardware is unsafe."],
["Why is steering treated as safety-critical?",["It directly affects vehicle control","It changes radio volume","It determines fuel price"],0,"Steering condition directly affects control."]]}],reward:{knowledge:7,confidence:5,safety:7,next:"Suspension System"}},
4:{week:"WEEK 1 · FOUNDATION",title:"Suspension System",summary:"Learn how the suspension supports the vehicle, keeps axles aligned, and protects stability under load.",time:"24–30 minutes",focus:"Inspect springs, mounts, shocks, and air suspension",coach:"Suspension parts carry tremendous load. Look for cracks, shifting, missing hardware, leaks, and anything that allows an axle to move out of position.",steps:[
{id:"welcome",label:"Mission Brief",desc:"Understand suspension stability.",type:"brief",heading:"Support the truck safely.",body:"The suspension supports the vehicle and cargo while helping the tires remain in contact with the road. Damaged springs, mounts, shocks, air bags, or hardware can affect stability and axle alignment.",note:"A cracked, broken, shifted, or missing load-bearing suspension part is a serious safety concern."},
{id:"learn",label:"Suspension Logic",desc:"Learn the major checks.",type:"cards",heading:"Inspect support, alignment, and control.",body:"Use these checks across spring and air-suspension systems.",cards:[["Springs & Air Bags","No cracks, breaks, missing leaves, shifting, cuts, abrasions, or leaks."],["Mounts & Hangers","Secure, not cracked or broken, and hardware present."],["U-Bolts","Present, tight, and not cracked, broken, or shifted."],["Shock Absorbers","Secure and not leaking or damaged."]]},
{id:"visual",label:"Suspension Parts",desc:"Recognize support components.",type:"components",heading:"Know the parts carrying the load.",body:"Inspect the system installed on the vehicle in front of you.",components:[["Leaf Springs","Not cracked, broken, missing, or shifted out of position."],["Spring Hangers","Secure to the frame and not cracked or broken."],["Shackles","Secure, aligned, and not excessively worn or damaged."],["U-Bolts","Present, tight, and holding the axle securely."],["Air Bags","Properly inflated where applicable, secure, and free of cuts, abrasion, and leaks."],["Air Lines","Secure and free of cuts, cracks, rubbing, and leaks."],["Shock Absorbers","Secure at both ends and not leaking."],["Torque Rods / Radius Rods","Secure, straight, and bushings not excessively worn."]]},
{id:"voice",label:"Suspension Voice Drill",desc:"Speak the safety checks.",type:"voice",heading:"Describe the suspension clearly.",body:"Mention the installed suspension type and its key defects.",prompt:"The suspension components are securely mounted. Springs are not cracked, broken, missing, or shifted. U-bolts and mounts are secure. Air bags and lines show no cuts, abrasion, or leaks, and the shock absorbers are secure and not leaking."},
{id:"quiz",label:"Foundation Check",desc:"Complete the free Foundation Series.",type:"quiz",heading:"Finish Mission 4 and complete your free foundation.",questions:[
["Which leaf-spring condition is unsafe?",["Cracked, broken, missing, or shifted leaves","Normal surface dust","Manufacturer label"],0,"Load-bearing spring damage or shifting is unsafe."],
["What do U-bolts help secure?",["The axle to the suspension","The radio to the dash","The trailer doors"],0,"U-bolts hold the axle and suspension relationship securely."],
["What should be checked on air bags?",["Cuts, abrasion, security, inflation, and leaks","Fuel level","Tread depth"],0,"Air bags must be secure and free from damage and leakage."],
["What indicates a shock absorber problem?",["Leakage, damage, or loose mounting","A clean exterior","A printed part number"],0,"Shocks should be secure, undamaged, and not leaking."],
["Why does suspension condition matter?",["It supports load, stability, tire contact, and axle alignment","It controls music","It sets dispatch time"],0,"Suspension condition affects support and stability."]]}],reward:{knowledge:8,confidence:6,safety:8,next:"Unlock Brakes and the Complete System"}},
5:{"week":"WEEK 1 · CORE SAFETY","title":"Brake System","summary":"Learn the service-brake components, inspect for contamination and damage, and explain why brake condition is safety-critical.","time":"25–30 minutes","focus":"Inspect brake components and defects","coach":"Brakes are never a place for vague language. Name the part, state its condition, and call out contamination, looseness, damage, or excessive travel.","steps":[{"id":"welcome","label":"Mission Brief","desc":"Set today’s brake-safety target.","type":"brief","heading":"Inspect the system that must stop the vehicle.","body":"The brake system converts driver input into stopping force. You will learn the visible foundation-brake components and the defects that can reduce stopping ability.","note":"Treat cracked, loose, contaminated, missing, or excessively worn brake components as serious safety defects."},{"id":"learn","label":"Brake Logic","desc":"Learn the four major checks.","type":"cards","heading":"Use a complete brake inspection pattern.","body":"Apply these checks to each visible brake assembly.","cards":[["Mounting & Security","Components, hoses, chambers, and hardware should be secure."],["Condition","Look for cracks, breaks, bends, missing parts, or excessive wear."],["Contamination","Linings and drums or rotors should not be contaminated by oil or grease."],["Adjustment","Pushrod travel and adjustment must remain within the applicable limits."]]},{"id":"visual","label":"Brake Components","desc":"Recognize the foundation brake.","type":"components","heading":"Follow the stopping force from air chamber to wheel.","body":"Inspect the system installed on the vehicle.","components":[["Brake Chamber","Secure, not cracked or damaged, and not leaking air.","Converts air pressure into mechanical force.","Loose mounting, dents, cracks, air leaks.","Check mounting and listen for leakage."],["Slack Adjuster","Secure, not damaged, and properly adjusted.","Transfers chamber movement to the brake mechanism.","Excessive pushrod travel, loose or damaged hardware.","Use the correct procedure for adjustment checks."],["Pushrod","Straight, secure, and within allowable travel.","Moves the slack adjuster when brakes apply.","Bent rod, missing retaining hardware, excessive travel.","Do not guess limits; use the applicable standard."],["Brake Hose / Line","Secure, not cut, cracked, chafed, leaking, or rubbing.","Carries air to the brake chamber.","Leaks, abrasion, cuts, loose routing.","Check both condition and routing."],["Brake Drum / Rotor","Not cracked, broken, excessively worn, or contaminated.","Provides the friction surface for braking.","Cracks, damage, oil or grease contamination.","Look through inspection openings where available."],["Brake Lining / Pad","Present, securely mounted, not dangerously thin, and not contaminated.","Creates friction against the drum or rotor.","Thin, missing, cracked, loose, oil-soaked lining.","State both thickness and contamination checks."]]},{"id":"voice","label":"Brake Voice Drill","desc":"Speak a complete brake inspection.","type":"voice","heading":"Use exact safety language.","body":"Cover mounting, hoses, chambers, adjustment, friction surfaces, and contamination.","prompt":"The brake chamber, hoses, slack adjuster, pushrod, drum or rotor, and brake lining are securely mounted and not damaged. There are no air leaks, excessive pushrod travel, cracks, missing parts, or oil and grease contamination."},{"id":"quiz","label":"Brake Safety Check","desc":"Prove brake-system knowledge.","type":"quiz","heading":"Complete the brake-system check.","questions":[["What should brake hoses be checked for?",["Cuts, cracks, chafing, leaks, and secure routing","Paint color","Fuel grade"],0,"Brake hoses must be secure and free of damage and leakage."],["What is unsafe on brake lining?",["Oil or grease contamination","Normal manufacturer markings","Dry road dust"],0,"Contamination can reduce friction and stopping ability."],["What does excessive pushrod travel suggest?",["Possible improper adjustment or brake defect","Correct tire pressure","A clean air filter"],0,"Excessive travel can indicate an adjustment or component problem."],["What should be checked on a brake chamber?",["Security, damage, and air leakage","Trailer height only","Radio signal"],0,"The chamber must be secure, undamaged, and leak-free."],["Why are brakes safety-critical?",["They directly determine stopping ability","They control cargo temperature","They set route mileage"],0,"Brake condition directly affects the ability to stop safely."]]}],"reward":{"knowledge":9,"confidence":6,"safety":10,"next":"Wheels, Rims and Tires"},"voiceChecks":[{"label":"secure mounting","terms":["secure","mounted"]},{"label":"air leaks","terms":["leak"]},{"label":"adjustment or pushrod travel","terms":["pushrod","travel","adjust"]},{"label":"lining contamination","terms":["oil","grease","contamination"]}]},
6:{"week":"WEEK 1 · CORE SAFETY","title":"Wheels, Rims and Tires","summary":"Inspect tires, rims, hubs, lug nuts, and valve stems using specific, professional defect language.","time":"24–30 minutes","focus":"Master wheel-end inspection","coach":"Never stop at saying the tire looks good. Cover inflation, tread, damage, matching, rim condition, lug nuts, hub seals, and valve stems.","steps":[{"id":"welcome","label":"Mission Brief","desc":"Set the wheel-end target.","type":"brief","heading":"Protect traction and wheel security.","body":"Wheel-end defects can cause loss of control, blowouts, wheel separation, and roadside violations. Today you will build a complete tire, rim, and hub inspection.","note":"Use a gauge for inflation when required. Appearance alone is not a reliable pressure check."},{"id":"learn","label":"Wheel-End Logic","desc":"Learn the complete pattern.","type":"cards","heading":"Inspect tire, rim, fasteners, and hub.","body":"Move through the wheel assembly in the same order every time.","cards":[["Tire","Inflation, tread depth, wear, cuts, bulges, separation, and matching."],["Rim","No cracks, bends, illegal welds, or damage."],["Lug Nuts","Present, tight, and without rust trails or shiny threads indicating looseness."],["Hub & Valve","No seal leaks; cap secure; valve stem and cap present and not damaged."]]},{"id":"visual","label":"Wheel-End Parts","desc":"Recognize every inspection point.","type":"components","heading":"Build a professional wheel-end checklist.","body":"Inspect both condition and security.","components":[["Tire Tread","Adequate depth, even wear, and no exposed fabric or cords.","Provides road contact and traction.","Low tread, uneven wear, exposed cords.","Use the required minimum for the axle and tire position."],["Sidewall","No cuts, bulges, abrasions, separation, or exposed cords.","Contains pressure and supports the load.","Bulges, cuts, bubbles, weather cracking.","Inspect both inner and outer sidewalls where visible."],["Rim","Not cracked, bent, damaged, or illegally welded.","Supports the tire and transfers load to the hub.","Cracks, bends, elongated holes, unauthorized welds.","Pay attention around bolt holes."],["Lug Nuts","All present, secure, and without looseness indicators.","Clamps the wheel to the hub.","Missing nuts, rust trails, shiny threads, wallowed holes.","Rust trails can indicate movement."],["Hub Seal","Not leaking; hub oil level acceptable where visible.","Lubricates wheel bearings.","Oil leakage, loose cap, low visible level.","Distinguish hub oil from other fluid."],["Valve Stem","Secure, not damaged, and capped.","Allows inflation and pressure measurement.","Bent or damaged stem, missing cap, leakage.","Make sure dual-wheel stems are accessible."]]},{"id":"voice","label":"Wheel-End Voice Drill","desc":"Speak the inspection in order.","type":"voice","heading":"Cover every wheel-end category.","body":"Use specific tire, rim, lug, hub, and valve language.","prompt":"The tires are properly inflated, have adequate tread depth, and show no cuts, bulges, separation, or exposed cords. The rims are not cracked or bent, all lug nuts are present and tight, the hub seal is not leaking, and the valve stem is secure and capped."},{"id":"quiz","label":"Wheel-End Check","desc":"Prove wheel-end knowledge.","type":"quiz","heading":"Complete the wheel-end safety check.","questions":[["What can rust trails around lug nuts indicate?",["Possible looseness or wheel movement","Correct alignment","New hardware"],0,"Rust trails may indicate a loose fastener."],["Which tire defect is unsafe?",["Bulges or exposed cords","A molded brand name","Normal tread pattern"],0,"Bulges and exposed cords indicate structural damage."],["What should a rim be checked for?",["Cracks, bends, damage, and illegal welds","Fuel level","Mirror adjustment"],0,"Rim condition is a core wheel-end check."],["What should be checked at the hub seal?",["Leakage and level where visible","Radio volume","Trailer length"],0,"A leaking or low hub can threaten wheel bearings."],["Why is visual inflation alone insufficient?",["A tire can appear normal while pressure is wrong","It changes tread color","It makes the rim heavier"],0,"Pressure should be verified using the proper method."]]}],"reward":{"knowledge":9,"confidence":7,"safety":9,"next":"Driver-Side Review"},"voiceChecks":[{"label":"inflation and tread","terms":["inflated","tread"]},{"label":"tire damage","terms":["cut","bulge","cord","separation"]},{"label":"lug-nut security","terms":["lug","tight"]},{"label":"hub leakage","terms":["hub","leak"]}]},
7:{"week":"WEEK 1 · CORE SAFETY","title":"Driver-Side Engine-to-Cab Review","summary":"Combine engine, steering, suspension, brakes, and wheel-end checks into one smooth driver-side sequence.","time":"25–30 minutes","focus":"Connect the first six missions","coach":"Today is about sequence. Move from system to system without jumping around, and use the same safety language you have already practiced.","steps":[{"id":"welcome","label":"Mission Brief","desc":"Connect the foundation systems.","type":"brief","heading":"Turn separate lessons into one inspection flow.","body":"You have learned the major systems from the open hood through the steer axle. Today you will connect them into a repeatable driver-side sequence.","note":"Do not rush. Smooth order and complete language matter more than speed."},{"id":"learn","label":"Sequence Logic","desc":"Build the physical route.","type":"cards","heading":"Use location to protect memory.","body":"Anchor each system to where you physically stand.","cards":[["Under Hood","Fluids, hoses, belts, mounted components, steering."],["Steer Suspension","Springs or air bags, mounts, U-bolts, shocks."],["Steer Brakes","Chamber, hoses, slack adjuster, pushrod, friction surfaces."],["Steer Wheel End","Tire, rim, lug nuts, hub seal, valve stem."]]},{"id":"visual","label":"Review Stations","desc":"Practice four inspection stations.","type":"components","heading":"Move in one direction and finish each station.","body":"Use these as mental checkpoints.","components":[["Station 1 · Engine","Fluids, leakage, belts, hoses, wiring, mounted components."],["Station 2 · Steering","Gearbox, shaft, pitman arm, drag link, tie rod, hardware."],["Station 3 · Suspension & Brakes","Springs or bags, mounts, U-bolts, shocks, chamber, hoses, adjustment."],["Station 4 · Wheel End","Tire, rim, lug nuts, hub, valve stem."]]},{"id":"voice","label":"Connected Sequence Drill","desc":"Speak the combined inspection.","type":"voice","heading":"Move system by system.","body":"Practice one concise but complete sequence from engine to steer wheel.","prompt":"I inspect the engine compartment for secure components, proper fluid levels, damage, and leaks. I then inspect the steering, suspension, brakes, tire, rim, lug nuts, hub seal, and valve stem for proper mounting, condition, adjustment, and any defect that could make the vehicle unsafe."},{"id":"quiz","label":"Week 1 Review","desc":"Prove connected understanding.","type":"quiz","heading":"Finish the Week 1 core-safety review.","questions":[["What is the best way to avoid jumping around?",["Use a fixed physical sequence","Inspect only easy parts","Start somewhere different every time"],0,"A fixed route supports memory and completeness."],["Which system should include pushrod travel?",["Brakes","Steering","Cooling"],0,"Pushrod travel belongs to the brake inspection."],["Which item belongs at the wheel end?",["Hub seal","Alternator","Pitman arm"],0,"The hub seal is part of the wheel-end inspection."],["Why finish one station before moving?",["To reduce missed items","To increase engine speed","To change tire pressure"],0,"Completing each station protects sequence."],["What matters more than speed today?",["Smooth order and complete safety language","Finishing in five minutes","Using fewer component names"],0,"This mission builds sequence and completeness."]]}],"reward":{"knowledge":8,"confidence":8,"safety":8,"next":"Driver Door and Fuel Area"},"voiceChecks":[{"label":"engine condition and leaks","terms":["engine","leak"]},{"label":"steering and suspension","terms":["steering","suspension"]},{"label":"brakes","terms":["brake"]},{"label":"wheel end","terms":["tire","rim","lug","hub"]}]},
8:{"week":"WEEK 2 · WALKAROUND","title":"Driver Door and Fuel Area","summary":"Inspect mirrors, doors, steps, fuel tank, cap, straps, battery area, frame, and visible safety equipment.","time":"22–28 minutes","focus":"Master the driver-side cab area","coach":"The driver-side cab area looks simple, but it contains several security, leakage, access, and structural checks.","steps":[{"id":"welcome","label":"Mission Brief","desc":"Set the cab-area target.","type":"brief","heading":"Inspect access, visibility, fuel, and structure.","body":"Today you will move from the steer wheel toward the driver door and fuel area, checking the components that support safe entry, visibility, fuel containment, and frame integrity.","note":"Fuel leaks, loose tanks, damaged steps, and insecure doors require clear attention."},{"id":"learn","label":"Cab-Area Logic","desc":"Use four categories.","type":"cards","heading":"Inspect access, visibility, containment, and structure.","body":"Organize the area instead of memorizing disconnected parts.","cards":[["Visibility","Mirror brackets and glass secure, clean, and not damaged."],["Access","Door, hinges, seals, steps, and grab handles secure."],["Fuel","Tank, cap, straps, and lines secure and not leaking."],["Structure","Frame, battery box, and visible mounting hardware secure and undamaged."]]},{"id":"visual","label":"Driver-Side Cab Parts","desc":"Recognize the inspection points.","type":"components","heading":"Inspect the cab and fuel area in order.","body":"Finish one category before moving rearward.","components":[["Mirror Assembly","Bracket secure; glass clean, adjusted, and not cracked.","Provides rear and side visibility.","Loose bracket, cracked glass, obstruction.","Check both mounting and usable view."],["Door & Hinges","Door opens and closes properly; hinges and latch secure.","Provides safe access and occupant protection.","Loose hinges, damaged latch, torn seal.","Confirm secure closure."],["Steps & Grab Handles","Secure, clean enough for safe use, and not damaged.","Supports safe entry and exit.","Loose, bent, broken, excessively slippery.","Treat access defects as fall hazards."],["Fuel Tank & Straps","Tank and straps secure; no damage or leakage.","Stores vehicle fuel safely.","Leaks, loose straps, dents, damaged mounts.","Check underneath and around seams."],["Fuel Cap","Present, secure, and seal in serviceable condition.","Prevents contamination and fuel loss.","Missing cap, damaged seal, improper fit.","Verify it is fully secured."],["Frame / Battery Area","Frame and box secure, not cracked or damaged; cover secure.","Supports the vehicle and protects batteries.","Cracks, loose hardware, exposed batteries.","Never ignore structural cracks."]]},{"id":"voice","label":"Cab-Area Voice Drill","desc":"Speak the driver-side checks.","type":"voice","heading":"Cover visibility, access, fuel, and frame.","body":"Use a smooth front-to-rear description.","prompt":"The mirror, door, hinges, steps, and grab handles are secure and not damaged. The fuel tank, straps, cap, and lines are secure with no leaks. The battery area and frame are secure and show no cracks or damage."},{"id":"quiz","label":"Cab-Area Check","desc":"Prove driver-side cab knowledge.","type":"quiz","heading":"Complete the driver-door and fuel-area check.","questions":[["What should fuel-tank straps be checked for?",["Security and damage","Tread depth","Air pressure"],0,"Straps must hold the tank securely."],["What makes a step unsafe?",["Loose, bent, broken, or excessively slippery condition","A manufacturer label","Normal texture"],0,"Steps must support safe entry and exit."],["What should mirror glass be checked for?",["Clean usable view and no cracks","Fuel level","Brake adjustment"],0,"Mirrors must provide a clear, undamaged view."],["What should be checked on the fuel cap?",["Presence, security, and seal condition","Tire brand","Trailer height"],0,"The cap must be present and secure."],["Why inspect the frame?",["Cracks or damage can affect structural integrity","It controls the radio","It fills the air tanks"],0,"Frame condition is structurally important."]]}],"reward":{"knowledge":7,"confidence":7,"safety":7,"next":"Drive Axle"},"voiceChecks":[{"label":"mirror and door security","terms":["mirror","door","secure"]},{"label":"steps and handles","terms":["step","handle"]},{"label":"fuel leakage","terms":["fuel","leak"]},{"label":"frame condition","terms":["frame","crack","damage"]}]},
9:{"week":"WEEK 2 · WALKAROUND","title":"Drive Axle","summary":"Inspect drive-axle suspension, brakes, tires, rims, lug nuts, axle seals, and spacing between dual tires.","time":"24–30 minutes","focus":"Apply wheel-end skills to the drive axle","coach":"The drive axle repeats familiar checks but adds dual tires, axle seals, and load-bearing suspension details. Use what you already know.","steps":[{"id":"welcome","label":"Mission Brief","desc":"Set the drive-axle target.","type":"brief","heading":"Inspect the axle carrying power and load.","body":"Today you will apply suspension, brake, and wheel-end logic to the drive axle. You will also inspect dual-tire spacing and axle-seal condition.","note":"Check both tires in a dual set, including the inner sidewalls and the space between them."},{"id":"learn","label":"Drive-Axle Logic","desc":"Reuse proven patterns.","type":"cards","heading":"Inspect suspension, brakes, and dual wheel ends.","body":"Consistency makes this large area manageable.","cards":[["Suspension","Springs or bags, mounts, U-bolts, shocks, torque rods."],["Brakes","Chambers, hoses, slack adjusters, pushrods, drums or rotors, linings."],["Dual Tires","Inflation, tread, damage, matching, spacing, and debris."],["Axle & Wheels","Rims, lug nuts, axle seal, valve stems, mud flaps where applicable."]]},{"id":"visual","label":"Drive-Axle Parts","desc":"Recognize the added checks.","type":"components","heading":"Inspect both sides of the dual assembly.","body":"Use a light and safe viewing angle where necessary.","components":[["Drive Suspension","Secure and free of cracks, breaks, shifting, cuts, or leaks."],["Drive Brakes","Secure, adjusted, not leaking, damaged, or contaminated."],["Dual Tires","Properly inflated, matched where required, not touching, and free of debris between them."],["Inner Sidewalls","No cuts, bulges, abrasions, or exposed cords."],["Axle Seal","Secure and not leaking lubricant."],["Mud Flaps / Splash Guards","Present where required, secure, and not damaged."]]},{"id":"voice","label":"Drive-Axle Voice Drill","desc":"Speak the complete axle inspection.","type":"voice","heading":"Include both dual tires.","body":"Connect suspension, brakes, tires, wheels, and seal checks.","prompt":"The drive-axle suspension and brakes are securely mounted, not damaged, and show no leaks or contamination. Both dual tires are properly inflated, have adequate tread, are not touching, and have no debris between them. The rims, lug nuts, valve stems, and axle seal are secure and serviceable."},{"id":"quiz","label":"Drive-Axle Check","desc":"Prove drive-axle knowledge.","type":"quiz","heading":"Complete the drive-axle safety check.","questions":[["What should be checked between dual tires?",["Proper spacing and no debris","Fuel level","Mirror adjustment"],0,"Duals must not touch and should be free of lodged debris."],["Which sidewall is easy to miss?",["The inner sidewall","The windshield","The fuel cap"],0,"Inner sidewalls require deliberate inspection."],["What should the axle seal show?",["No lubricant leakage","Correct paint color","Air pressure"],0,"The axle seal must not leak."],["Which checks repeat from the steer axle?",["Brakes, tires, rims, lug nuts, and valve stems","Horn and wipers","Seat belt only"],0,"Core brake and wheel checks repeat at the drive axle."],["Why inspect both tires in a dual set?",["Either tire can have pressure or structural defects","Only one supports weight","They control steering"],0,"Both tires must be safe and serviceable."]]}],"reward":{"knowledge":8,"confidence":8,"safety":9,"next":"Coupling System"},"voiceChecks":[{"label":"suspension and brakes","terms":["suspension","brake"]},{"label":"dual tires","terms":["dual","tire"]},{"label":"spacing and debris","terms":["touch","debris","between"]},{"label":"axle seal leakage","terms":["axle","seal","leak"]}]},
10:{"week":"WEEK 2 · WALKAROUND","title":"Coupling System","summary":"Master the fifth wheel, kingpin, locking jaws, platform, release arm, apron, air and electrical lines, and mounting hardware.","time":"28–35 minutes","focus":"Verify a secure tractor-trailer connection","coach":"The coupling system keeps the tractor and trailer together. Slow down, look directly at the locking area, and describe every security check.","steps":[{"id":"welcome","label":"Mission Brief","desc":"Set the coupling target.","type":"brief","heading":"Verify the connection that holds the combination together.","body":"Today you will inspect the fifth wheel and all visible coupling components. A missed lock, gap, damaged line, or loose mount can lead to a catastrophic separation.","note":"Never rely on assumption. Visually verify the locking jaws and connection."},{"id":"learn","label":"Coupling Logic","desc":"Use four connection checks.","type":"cards","heading":"Inspect lock, contact, mounting, and lines.","body":"Build the same sequence every time.","cards":[["Lock","Jaws fully closed around the kingpin; release arm secured."],["Contact","Trailer apron resting flat on fifth wheel with no visible gap."],["Mounting","Fifth wheel, platform, frame, bolts, and slider pins secure."],["Lines","Air and electrical lines connected, supported, and free of damage or leaks."]]},{"id":"visual","label":"Coupling Components","desc":"Recognize every connection point.","type":"components","heading":"Inspect from lines to locking jaws.","body":"Use direct visual confirmation.","components":[["Air Lines","Connected correctly, sealed, supported, and free of cuts, abrasion, tangles, or leaks.","Carry service and emergency air between tractor and trailer.","Leaks, crossed lines, rubbing, poor support.","Check glad-hand seals and routing."],["Electrical Line","Connected, latched, supported, and not damaged.","Powers trailer lights and electrical systems.","Loose plug, exposed wiring, dragging line.","Keep it from rubbing or dragging."],["Fifth-Wheel Platform","Secure to frame and not cracked, bent, or damaged.","Supports the fifth-wheel assembly.","Loose bolts, cracks, broken welds.","Inspect mounting hardware carefully."],["Fifth-Wheel Plate","Properly greased, tilted appropriately when uncoupled, and not damaged.","Supports and pivots under the trailer apron.","Damage, contamination, poor lubrication.","When coupled, verify full contact."],["Locking Jaws","Fully closed around the kingpin shank.","Locks tractor to trailer.","Open or incomplete lock, damage, wrong position.","Look directly behind the fifth wheel."],["Kingpin & Apron","Kingpin not bent or damaged; apron flat on fifth wheel with no gap.","Provides the primary coupling interface.","Bent kingpin, cracked apron, visible gap.","No daylight should show between connected surfaces."],["Release Arm / Safety Latch","Arm seated and secured; safety latch engaged where equipped.","Prevents unintended jaw release.","Arm out, bent, unsecured, missing latch.","Confirm the handle is in the locked position."],["Slider Pins / Mounts","Pins engaged and hardware secure.","Locks adjustable fifth wheel to frame rails.","Missing or disengaged pins, loose mounts.","Verify pins on both sides where visible."]]},{"id":"voice","label":"Coupling Voice Drill","desc":"Speak the connection verification.","type":"voice","heading":"Use direct locking language.","body":"Cover lines, mounting, contact, jaws, kingpin, release arm, and slider pins.","prompt":"The air and electrical lines are connected, supported, and not damaged or leaking. The fifth wheel and platform are securely mounted. The trailer apron is flat with no gap, the locking jaws are fully closed around the kingpin, the release arm is secured, and the slider pins are engaged."},{"id":"quiz","label":"Coupling Safety Check","desc":"Prove coupling knowledge.","type":"quiz","heading":"Complete the coupling-system check.","questions":[["Where should locking jaws close?",["Around the kingpin shank","Around the trailer frame","Around an air line"],0,"The jaws must fully close around the kingpin shank."],["What does a visible gap suggest?",["Improper trailer-to-fifth-wheel contact","Correct coupling","Proper tire pressure"],0,"The apron should rest flat with no gap."],["What should be checked on air lines?",["Connection, seals, support, damage, and leaks","Tread depth","Mirror angle"],0,"Air lines must be connected, supported, and leak-free."],["What should slider pins do?",["Be fully engaged","Hang below the frame","Remain partly withdrawn"],0,"Slider pins must lock the assembly securely."],["Why inspect the release arm?",["It must be seated and secured against unintended release","It controls engine oil","It adjusts mirrors"],0,"The release mechanism must remain locked."]]}],"reward":{"knowledge":10,"confidence":8,"safety":10,"next":"Trailer Front and Side"},"voiceChecks":[{"label":"air and electrical lines","terms":["air","electrical","line"]},{"label":"no gap","terms":["no gap","flat"]},{"label":"locking jaws and kingpin","terms":["jaw","kingpin"]},{"label":"release arm and slider pins","terms":["release","slider","pin"]}]},
11:{"week":"WEEK 2 · WALKAROUND","title":"Trailer Front and Side","summary":"Inspect the trailer header board, frame, body, lights, reflectors, landing gear, doors, and side structure.","time":"22–28 minutes","focus":"Inspect trailer structure and support","coach":"Keep the trailer inspection structural: secure, straight, undamaged, properly supported, and visible to other road users.","steps":[{"id":"welcome","label":"Mission Brief","desc":"Set the trailer-side target.","type":"brief","heading":"Inspect structure, support, and visibility.","body":"Today you will move from the front of the trailer down the driver side, checking the trailer body, frame, lights, reflectors, landing gear, and visible cargo-containment components.","note":"Look above, below, and along the full length instead of inspecting only at eye level."},{"id":"learn","label":"Trailer-Side Logic","desc":"Use four categories.","type":"cards","heading":"Inspect structure, support, visibility, and containment.","body":"These categories keep the long trailer organized.","cards":[["Structure","Header board, body, frame, crossmembers, and side panels."],["Support","Landing gear, braces, feet, crank handle, and mounting."],["Visibility","Marker lights, reflectors, reflective tape, and conspicuity devices."],["Containment","Doors, hinges, latches, seals, and visible cargo security where applicable."]]},{"id":"visual","label":"Trailer-Side Parts","desc":"Recognize the main checks.","type":"components","heading":"Walk the trailer from front to rear.","body":"Keep important structural checks in sequence.","components":[["Header Board / Front Wall","Secure, upright, and free of cracks, holes, or damage."],["Trailer Frame & Crossmembers","Straight, secure, and not cracked, bent, or broken."],["Landing Gear","Fully raised for travel, secure, not damaged, handle stowed."],["Side Panels / Floor Area","No holes, separation, loose panels, or major damage."],["Lights & Reflectors","Correct color, clean, secure, and working."],["Reflective Tape","Present where required, visible, and securely attached."]]},{"id":"voice","label":"Trailer-Side Voice Drill","desc":"Speak the structural inspection.","type":"voice","heading":"Cover front wall through landing gear.","body":"Use clear security and damage language.","prompt":"The trailer front wall, frame, crossmembers, and side panels are secure and show no cracks, holes, bends, or separation. The landing gear is fully raised, securely mounted, and the handle is stowed. Lights, reflectors, and reflective tape are clean, secure, and serviceable."},{"id":"quiz","label":"Trailer-Side Check","desc":"Prove structural knowledge.","type":"quiz","heading":"Complete the trailer-side check.","questions":[["How should landing gear be positioned for travel?",["Fully raised and secure","Partly lowered","Resting on the road"],0,"Landing gear must be fully raised for travel."],["What should crossmembers be checked for?",["Cracks, bends, breaks, and security","Fuel level","Mirror angle"],0,"Crossmembers support trailer structure."],["What should marker lights and reflectors be?",["Correct color, clean, secure, and working","Painted over","Covered"],0,"Visibility devices must be usable and visible."],["What trailer-wall defect matters?",["Holes, separation, or major structural damage","A small manufacturer decal","Normal dirt"],0,"Structural wall defects can affect cargo containment."],["Where should the landing-gear handle be?",["Stowed securely","Hanging loose","Dragging"],0,"The crank handle must be secured."]]}],"reward":{"knowledge":7,"confidence":7,"safety":7,"next":"Trailer Axles and Suspension"},"voiceChecks":[{"label":"trailer structure","terms":["frame","crossmember","panel"]},{"label":"landing gear","terms":["landing","raised","stowed"]},{"label":"lights and reflectors","terms":["light","reflector"]},{"label":"no structural damage","terms":["crack","hole","bend","damage"]}]},
12:{"week":"WEEK 2 · WALKAROUND","title":"Trailer Axles and Suspension","summary":"Inspect trailer suspension, brakes, dual tires, rims, lug nuts, axle seals, and tandem-position hardware.","time":"25–30 minutes","focus":"Master the trailer running gear","coach":"Use the drive-axle pattern again, then add tandem slider pins and trailer-specific structural checks.","steps":[{"id":"welcome","label":"Mission Brief","desc":"Set the trailer-axle target.","type":"brief","heading":"Inspect the running gear supporting the trailer.","body":"Today you will inspect trailer suspension, brakes, wheels, dual tires, axle seals, and tandem hardware. Most checks repeat from the drive axle, which is exactly why sequence matters.","note":"Inspect every axle and both sides. Do not assume identical condition."},{"id":"learn","label":"Trailer-Axle Logic","desc":"Reuse the drive-axle pattern.","type":"cards","heading":"Inspect support, stopping, wheel ends, and tandem lock.","body":"Complete one axle before moving to the next.","cards":[["Suspension","Springs or bags, hangers, U-bolts, shocks, torque rods."],["Brakes","Chambers, hoses, adjustment, drums or rotors, linings."],["Wheel Ends","Dual tires, rims, lug nuts, valve stems, hub or axle seals."],["Tandem Hardware","Slider rails, locking pins, stops, and positioning hardware."]]},{"id":"visual","label":"Trailer Running Gear","desc":"Recognize the added trailer checks.","type":"components","heading":"Inspect each axle as a complete station.","body":"Use the same language on every axle.","components":[["Trailer Suspension","Secure and free of cracks, breaks, shifting, cuts, abrasion, or leaks."],["Trailer Brakes","Secure, adjusted, not leaking, damaged, or contaminated."],["Dual Tires","Inflated, adequate tread, no damage, touching, or debris."],["Rims & Lug Nuts","Rims undamaged; all lug nuts present and tight."],["Axle / Hub Seals","Secure and not leaking lubricant."],["Tandem Slider Pins","Fully engaged and locked on both sides where visible."]]},{"id":"voice","label":"Trailer-Axle Voice Drill","desc":"Speak the running-gear inspection.","type":"voice","heading":"Cover each axle and tandem lock.","body":"Use a repeatable suspension-to-wheel-end sequence.","prompt":"The trailer suspension and brake components on each axle are securely mounted, properly adjusted, and show no damage, leaks, or contamination. The dual tires, rims, lug nuts, valve stems, and axle seals are serviceable, and the tandem slider pins are fully engaged and locked."},{"id":"quiz","label":"Trailer-Axle Check","desc":"Prove running-gear knowledge.","type":"quiz","heading":"Complete the trailer running-gear check.","questions":[["What must tandem slider pins be?",["Fully engaged and locked","Partly withdrawn","Missing"],0,"Slider pins must secure the tandem position."],["Should every axle be inspected?",["Yes, each axle and both sides","Only the front axle","Only one tire"],0,"Each axle can have different defects."],["Which checks repeat from the drive axle?",["Suspension, brakes, dual tires, rims, lugs, and seals","Horn and mirrors","Oil dipstick"],0,"Trailer running gear repeats the same core systems."],["What should dual tires not do?",["Touch each other","Have tread","Use valve stems"],0,"Dual tires require proper spacing."],["What should axle seals show?",["No leakage","Fresh paint","Air pressure"],0,"Lubricant leakage requires attention."]]}],"reward":{"knowledge":8,"confidence":8,"safety":9,"next":"Rear of Trailer"},"voiceChecks":[{"label":"suspension and brakes","terms":["suspension","brake"]},{"label":"dual tires and wheels","terms":["dual","tire","rim","lug"]},{"label":"seal leakage","terms":["seal","leak"]},{"label":"tandem pins","terms":["tandem","pin","locked"]}]},
13:{"week":"WEEK 2 · WALKAROUND","title":"Rear of Trailer","summary":"Inspect rear doors, hinges, latches, lights, reflectors, bumper, splash guards, license plate, and cargo security.","time":"20–25 minutes","focus":"Secure the rear and remain visible","coach":"The rear inspection protects cargo containment and makes sure other drivers can see your signals and trailer outline.","steps":[{"id":"welcome","label":"Mission Brief","desc":"Set the rear-trailer target.","type":"brief","heading":"Inspect containment, impact protection, and visibility.","body":"Today you will inspect the back of the trailer from top to bottom: doors, hardware, lights, reflectors, bumper, splash guards, plate, and visible cargo security.","note":"Stand where you can inspect both door hardware and all rear lighting without entering traffic."},{"id":"learn","label":"Rear Logic","desc":"Use three categories.","type":"cards","heading":"Inspect containment, visibility, and protection.","body":"Finish the rear before beginning the passenger side.","cards":[["Containment","Doors, hinges, latches, seals, locking bars, and cargo securement."],["Visibility","Tail, brake, turn, clearance, plate lights, reflectors, and tape."],["Protection","Bumper or underride guard, mud flaps, and rear structure."]]},{"id":"visual","label":"Rear Components","desc":"Recognize the full rear check.","type":"components","heading":"Inspect top to bottom.","body":"Do not skip lights mounted high on the trailer.","components":[["Doors & Hinges","Secure, closed, and not damaged; hardware present."],["Latches / Locking Bars","Fully engaged, secure, and not bent or damaged."],["Rear Lights","Correct color, clean, secure, and working."],["Reflectors / Tape","Present, visible, and securely attached."],["Bumper / Underride Guard","Secure, straight, and not cracked or damaged."],["Mud Flaps / Plate","Flaps present and secure; plate and light present where required."]]},{"id":"voice","label":"Rear-Trailer Voice Drill","desc":"Speak the complete rear inspection.","type":"voice","heading":"Cover containment and visibility.","body":"Use a top-to-bottom sequence.","prompt":"The trailer doors, hinges, locking bars, latches, and seals are secure and not damaged. All rear lights, reflectors, and reflective tape are clean, correct, secure, and working. The bumper or underride guard, mud flaps, license plate, and rear structure are secure and serviceable."},{"id":"quiz","label":"Rear-Trailer Check","desc":"Prove rear inspection knowledge.","type":"quiz","heading":"Complete the rear-trailer check.","questions":[["What should locking bars and latches be?",["Fully engaged and secure","Left partly open","Removed"],0,"Door hardware must secure the cargo area."],["What should rear lights be checked for?",["Correct color, cleanliness, security, and operation","Fuel level","Tire pressure"],0,"Rear lights must communicate clearly."],["What should the underride guard be?",["Secure, straight, and undamaged","Loose","Missing"],0,"The guard is an important impact-protection component."],["Why inspect high-mounted lights?",["They are part of the required rear visibility system","They control brakes","They fill air tanks"],0,"All mounted lighting should be inspected."],["What should mud flaps be?",["Present, secure, and not damaged where required","Folded over the tire","Dragging"],0,"Splash guards must remain properly mounted."]]}],"reward":{"knowledge":7,"confidence":7,"safety":7,"next":"Passenger-Side Walkaround"},"voiceChecks":[{"label":"doors and latches","terms":["door","latch","locking"]},{"label":"rear lights","terms":["light","reflector"]},{"label":"underride guard","terms":["bumper","guard"]},{"label":"mud flaps and plate","terms":["mud","plate"]}]},
14:{"week":"WEEK 2 · WALKAROUND","title":"Passenger-Side Walkaround","summary":"Complete the exterior inspection by applying the same trailer, axle, coupling, fuel-area, and steer-axle checks on the passenger side.","time":"24–30 minutes","focus":"Finish the full exterior sequence","coach":"The passenger side is not a shortcut. Repeat every applicable check and pay attention to components that were hidden from the driver side.","steps":[{"id":"welcome","label":"Mission Brief","desc":"Set the passenger-side target.","type":"brief","heading":"Complete the exterior without omissions.","body":"Today you will walk from the rear of the trailer toward the front on the passenger side, repeating all applicable structural, wheel-end, suspension, brake, coupling-line, fuel-area, and steer-axle checks.","note":"Use symmetry as a memory aid, not as permission to assume condition."},{"id":"learn","label":"Return-Walk Logic","desc":"Reverse the physical route.","type":"cards","heading":"Inspect rear-to-front in complete stations.","body":"Finish every station before moving forward.","cards":[["Trailer Body","Panels, frame, lights, reflectors, doors or equipment."],["Trailer Axles","Suspension, brakes, dual tires, wheels, seals."],["Tractor Rear","Drive axle, frame, lines, coupling visibility."],["Cab to Steer","Tank or equipment, steps, mirror, steer wheel, suspension, brakes."]]},{"id":"visual","label":"Passenger-Side Stations","desc":"Review the return path.","type":"components","heading":"Repeat every applicable safety check.","body":"Look for defects visible only from this side.","components":[["Station 1 · Trailer Structure","Side panels, frame, crossmembers, lights, reflectors."],["Station 2 · Trailer Running Gear","Suspension, brakes, tires, rims, lugs, seals."],["Station 3 · Tractor Rear","Drive axle, frame, air and electrical-line routing."],["Station 4 · Cab Area","Tank or equipment, steps, door, mirror, exhaust where applicable."],["Station 5 · Steer Axle","Suspension, brakes, tire, rim, lug nuts, hub, valve stem."]]},{"id":"voice","label":"Passenger-Side Voice Drill","desc":"Speak the return sequence.","type":"voice","heading":"Show that both sides receive a real inspection.","body":"Move rear-to-front and name each station.","prompt":"On the passenger side, I inspect the trailer structure, lights, running gear, dual tires, wheels, brakes, and suspension. I continue forward through the tractor rear, lines, frame, cab area, mirror, steps, and steer axle, checking every applicable component for security, damage, leaks, wear, and unsafe condition."},{"id":"quiz","label":"Exterior Completion Check","desc":"Prove full-walkaround knowledge.","type":"quiz","heading":"Finish Week 2 with a complete exterior check.","questions":[["Should the passenger side be assumed safe because the driver side passed?",["No, every applicable component must be inspected","Yes","Only at night"],0,"Both sides require direct inspection."],["What is a useful memory aid?",["Use symmetrical stations while still checking actual condition","Skip repeated parts","Inspect randomly"],0,"Symmetry supports sequence but does not replace inspection."],["Which direction does this mission use?",["Rear to front on the passenger side","Only under the hood","Inside the cab only"],0,"The return walk completes the exterior."],["What can be visible only from one side?",["Damage, leaks, inner tire defects, or line routing","The vehicle VIN only","The horn"],0,"Viewing both sides reveals different defects."],["What does completing Day 14 mean?",["The exterior sequence has been learned and connected","The air-brake test is complete","The road test is waived"],0,"Day 14 completes the exterior curriculum foundation."]]}],"reward":{"knowledge":8,"confidence":9,"safety":8,"next":"In-Cab Inspection"},"voiceChecks":[{"label":"trailer structure and running gear","terms":["trailer","suspension","brake","tire"]},{"label":"tractor rear and lines","terms":["tractor","line","frame"]},{"label":"cab area","terms":["cab","mirror","step"]},{"label":"steer axle","terms":["steer","wheel","brake"]}]},
15:{"week":"WEEK 3 · CAB & READINESS","title":"In-Cab Inspection","summary":"Inspect safety equipment, controls, gauges, mirrors, seat belt, windshield, wipers, horn, heater, defroster, and emergency equipment.","time":"25–30 minutes","focus":"Master the in-cab safety check","coach":"Inside the cab, use a deliberate top-to-bottom and left-to-right sweep. Touch or point to each control as you name it.","steps":[{"id":"welcome","label":"Mission Brief","desc":"Set the in-cab target.","type":"brief","heading":"Verify the driver environment is safe and functional.","body":"Today you will inspect the cab before starting the engine. You will cover visibility, occupant protection, controls, warning devices, required emergency equipment, and general cab condition.","note":"Exact required equipment varies. Follow the current official manual and local procedure."},{"id":"learn","label":"In-Cab Logic","desc":"Use four inspection zones.","type":"cards","heading":"Inspect occupant, visibility, controls, and emergency equipment.","body":"A zone-based scan keeps the cab organized.","cards":[["Driver Protection","Seat belt, seat, doors, mirrors, and secure cab items."],["Visibility","Windshield, wipers, washers, mirrors, heater, and defroster."],["Controls & Gauges","Steering play, pedals, parking brakes, gauges, indicators."],["Emergency Equipment","Fire extinguisher, warning devices, spare fuses or applicable substitutes."]]},{"id":"visual","label":"In-Cab Components","desc":"Recognize the complete cab check.","type":"components","heading":"Build a consistent seated inspection.","body":"Point to each component as you speak.","components":[["Seat Belt","Secure, latches properly, and not cut, frayed, or damaged.","Restrains the driver.","Fraying, missing latch, loose mount.","Pull and latch it."],["Windshield & Mirrors","Clean, secure, properly adjusted, and free of unsafe damage.","Provides forward and surrounding visibility.","Cracks, obstruction, loose mounting.","Know applicable damage rules."],["Wipers / Washers","Arms and blades secure; operate correctly; fluid sprays.","Maintains visibility in weather.","Torn blades, poor contact, no fluid.","Test operation."],["Heater / Defroster","Operates and directs air to clear the windshield.","Maintains visibility and comfort.","No airflow, failure to defrost.","Demonstrate operation."],["Horn(s)","Electric and air horn operate where equipped.","Warns others.","No sound or weak operation.","Test safely."],["Emergency Equipment","Present, secure, charged or serviceable, and accessible.","Supports roadside emergencies.","Missing extinguisher, expired gauge, missing triangles.","State the required quantity and type for your jurisdiction."]]},{"id":"voice","label":"In-Cab Voice Drill","desc":"Speak the cab inspection.","type":"voice","heading":"Use a zone-based sequence.","body":"Cover protection, visibility, controls, warning devices, and emergency equipment.","prompt":"The seat belt and seat are secure, the windshield and mirrors are clean and serviceable, and the wipers, washers, heater, defroster, and horns operate correctly. The controls and gauges are present and undamaged, and the required fire extinguisher, warning devices, and emergency equipment are present, secure, and serviceable."},{"id":"quiz","label":"In-Cab Check","desc":"Prove cab knowledge.","type":"quiz","heading":"Complete the in-cab safety check.","questions":[["What should be checked on a seat belt?",["Mounting, latch, cuts, fraying, and damage","Fuel pressure","Tire tread"],0,"The belt must secure and function properly."],["Why test the defroster?",["It maintains windshield visibility","It fills air tanks","It locks the trailer"],0,"Defrosting is a visibility function."],["What should emergency equipment be?",["Present, secure, accessible, and serviceable","Hidden under cargo","Optional everywhere"],0,"Required equipment must be usable."],["What should mirrors be?",["Clean, secure, and properly adjusted","Folded inward","Covered"],0,"Mirrors must provide a usable view."],["What is the best in-cab method?",["A consistent zone-based sweep","Random checks","Only looking at gauges"],0,"A repeatable sweep reduces omissions."]]}],"reward":{"knowledge":9,"confidence":8,"safety":8,"next":"Safe Start and Warning Devices"},"voiceChecks":[{"label":"seat belt and visibility","terms":["seat belt","windshield","mirror"]},{"label":"wipers and defroster","terms":["wiper","defroster"]},{"label":"horns and controls","terms":["horn","control","gauge"]},{"label":"emergency equipment","terms":["extinguisher","warning","emergency"]}]},
16:{"week":"WEEK 3 · CAB & READINESS","title":"Safe Start and Warning Devices","summary":"Perform a safe engine start, verify gauges and warning lights, test controls, and confirm the vehicle is ready for air-brake procedures.","time":"22–28 minutes","focus":"Start safely and verify warnings","coach":"Before turning the key, protect against movement. After start, watch the gauges and warning indicators instead of immediately moving on.","steps":[{"id":"welcome","label":"Mission Brief","desc":"Set the safe-start target.","type":"brief","heading":"Start the vehicle without creating movement or missing warnings.","body":"Today you will practice the safe-start sequence: transmission position, parking brakes, clutch where applicable, engine start, gauge response, warning-light cycle, and basic control checks.","note":"Use the exact procedure required for the test vehicle and jurisdiction."},{"id":"learn","label":"Safe-Start Logic","desc":"Use four stages.","type":"cards","heading":"Prepare, start, observe, and verify.","body":"Do not skip the observation period.","cards":[["Prepare","Parking brakes applied, transmission neutral, clutch depressed where required."],["Start","Start engine safely without racing it."],["Observe","Oil pressure rises, voltmeter or ammeter responds, warning lights cycle."],["Verify","ABS indicators, gauges, and controls behave as expected."]]},{"id":"visual","label":"Start-Up Checks","desc":"Recognize normal indications.","type":"components","heading":"Know what should respond after start.","body":"Abnormal warnings require investigation.","components":[["Oil Pressure Gauge","Pressure rises into a safe range after start."],["Voltmeter / Ammeter","Shows charging-system response."],["Coolant Temperature","Begins in an appropriate range and rises normally."],["Air Pressure Gauges","Pressure builds in both systems where equipped."],["Warning Lights / Buzzer","Illuminate or sound during self-test and extinguish appropriately."],["ABS Indicator","Illuminates for self-test and follows expected sequence."]]},{"id":"voice","label":"Safe-Start Voice Drill","desc":"Speak the start sequence.","type":"voice","heading":"Show preparation and observation.","body":"Cover neutral, brakes, start, gauges, and warning indicators.","prompt":"Before starting, the parking brakes are applied and the transmission is in neutral. I start the engine safely and verify oil pressure, charging-system response, coolant temperature, and air-pressure buildup. I observe the warning lights, buzzer, and ABS indicator for the correct self-test and normal operation."},{"id":"quiz","label":"Safe-Start Check","desc":"Prove start-up knowledge.","type":"quiz","heading":"Complete the safe-start check.","questions":[["What should be confirmed before starting?",["Parking brakes applied and transmission neutral","Trailer doors open","Headlights removed"],0,"Prevent unintended movement before starting."],["What should oil pressure do after start?",["Rise into a safe range","Stay at zero","Disappear"],0,"Oil pressure should respond promptly."],["Why watch warning lights?",["To verify self-test and detect abnormal conditions","To set tire pressure","To couple the trailer"],0,"Warning indicators communicate system condition."],["What should dual air gauges do?",["Build pressure","Stay empty","Move backward"],0,"Air systems should build properly."],["Should the engine be raced immediately?",["No, start and observe safely","Yes, always","Only to test the horn"],0,"A controlled start supports safe system checks."]]}],"reward":{"knowledge":8,"confidence":8,"safety":9,"next":"Air-Brake Test"},"voiceChecks":[{"label":"parking brakes and neutral","terms":["parking","neutral"]},{"label":"oil and charging gauges","terms":["oil","volt","charge","ammeter"]},{"label":"air pressure","terms":["air","pressure","build"]},{"label":"warnings and ABS","terms":["warning","abs"]}]},
17:{"week":"WEEK 3 · CAB & READINESS","title":"Air-Brake Test","summary":"Practice the applied-leak, low-air warning, spring-brake activation, governor, and service-brake checks in the correct order.","time":"30–35 minutes","focus":"Master the air-brake sequence","coach":"Air-brake testing is procedural. Use the exact current state sequence and limits. Never substitute memory from another jurisdiction for the official standard.","steps":[{"id":"welcome","label":"Mission Brief","desc":"Set the air-brake target.","type":"brief","heading":"Demonstrate that the air system builds, holds, warns, and applies correctly.","body":"Today you will learn the logic of the complete air-brake test. Exact pressure thresholds, time limits, and vehicle setup must match the current official CDL manual and testing jurisdiction.","note":"Never move the vehicle during a static brake test unless the procedure specifically calls for a controlled movement check."},{"id":"learn","label":"Air-Brake Logic","desc":"Learn the purpose of each test.","type":"cards","heading":"Build, hold, warn, apply, and stop.","body":"Memorize the sequence together with the applicable official limits.","cards":[["Build & Governor","Verify pressure builds and governor cut-in and cut-out behavior."],["Leak Test","Measure pressure loss under the required brake application."],["Low-Air Warning","Confirm warning activates before pressure falls below the required threshold."],["Spring / Service Brakes","Confirm spring brakes activate and service brakes stop without pull."]]},{"id":"visual","label":"Air-Brake Tests","desc":"Understand what each test proves.","type":"components","heading":"Use official limits for scoring.","body":"This mission teaches structure; your manual supplies exact numbers.","components":[["Governor Cut-Out / Cut-In","Confirms compressor control stops and resumes pressure buildup appropriately."],["Static / Applied Leak Test","Checks whether the air system loses pressure faster than allowed."],["Low-Air Warning","Confirms visual and audible warning activates at the required pressure."],["Spring-Brake Activation","Confirms parking-brake controls activate before pressure becomes dangerously low."],["Parking-Brake Hold","Confirms tractor and trailer parking brakes hold against gentle power."],["Service-Brake Check","At low speed, confirms stopping response without pulling, delay, or unusual feel."]]},{"id":"voice","label":"Air-Brake Voice Drill","desc":"Speak the procedural sequence.","type":"voice","heading":"Use official limits when practicing locally.","body":"Cover build, governor, leaks, warning, spring brakes, parking hold, and service response.","prompt":"I build air pressure and verify governor operation. I perform the required static and applied leak checks using the official limits. I confirm the low-air warning activates and the spring brakes apply at the required pressure. I then verify the parking brakes hold and the service brake stops the vehicle smoothly without pulling."},{"id":"quiz","label":"Air-Brake Safety Check","desc":"Prove procedural understanding.","type":"quiz","heading":"Complete the air-brake knowledge check.","questions":[["Where should exact pressure limits come from?",["The current official CDL manual and testing procedure","A random video","A vehicle advertisement"],0,"Limits vary and must match the official standard."],["What does the leak test evaluate?",["Whether pressure loss exceeds the allowed rate","Tire tread depth","Mirror adjustment"],0,"The test evaluates system leakage."],["What should low-air warning include?",["Required visual and audible warning","Fuel alarm only","Trailer light only"],0,"The warning system must activate appropriately."],["What does a service-brake check evaluate?",["Stopping response, pull, delay, and unusual feel","Engine oil level","Landing gear"],0,"The moving check verifies actual brake response."],["Why is sequence important?",["Skipping or reordering can invalidate the procedure and miss defects","It changes paint color","It shortens the trailer"],0,"Air-brake tests depend on a disciplined sequence."]]}],"reward":{"knowledge":10,"confidence":10,"safety":10,"next":"Lights and Full Exterior Check"},"voiceChecks":[{"label":"governor operation","terms":["governor","cut"]},{"label":"leak checks","terms":["leak","applied","static"]},{"label":"low-air warning and spring brakes","terms":["low air","warning","spring"]},{"label":"parking and service brakes","terms":["parking","service","stop"]}]},
18:{"week":"WEEK 3 · CAB & READINESS","title":"Lights and Full Exterior Check","summary":"Perform a complete light check and connect the cab, exterior, and brake-light verification into one coordinated inspection.","time":"22–28 minutes","focus":"Verify all lighting and visibility systems","coach":"Lights require both operation and condition. Check color, cleanliness, security, damage, and function—not merely whether a bulb glows.","steps":[{"id":"welcome","label":"Mission Brief","desc":"Set the lighting target.","type":"brief","heading":"Make the vehicle visible and communicative.","body":"Today you will verify headlights, high beams, turn signals, hazards, clearance lights, marker lights, tail lights, brake lights, plate light, reflectors, and reflective tape.","note":"Use a helper, reflection, camera, or approved procedure to verify lights you cannot see from the controls."},{"id":"learn","label":"Lighting Logic","desc":"Use five checks on every lamp.","type":"cards","heading":"Verify color, cleanliness, security, damage, and operation.","body":"Apply the same language around the full vehicle.","cards":[["Correct Color","Each lamp and reflector must display the required color."],["Clean","Lens and reflector visible, not obscured."],["Secure","Housing and wiring properly mounted."],["Not Damaged","No broken lens, exposed bulb, or damaged wiring."],["Working","Illuminates or flashes as required."]]},{"id":"visual","label":"Lighting Groups","desc":"Organize the complete check.","type":"components","heading":"Move front, sides, and rear.","body":"Coordinate cab controls with exterior verification.","components":[["Front","Low beams, high beams, turn signals, hazards, clearance and identification lights."],["Sides","Marker lights, turn indicators where equipped, reflectors, reflective tape."],["Rear","Tail, brake, turn, hazard, clearance, identification, and plate lights."],["Tractor / Trailer ABS","Indicators operate according to expected self-test."],["Reflective Devices","Correct color, clean, secure, and visible."],["Wiring / Housings","Secure, insulated, and not damaged."]]},{"id":"voice","label":"Lighting Voice Drill","desc":"Speak the full light check.","type":"voice","heading":"Use the five-part lamp language.","body":"Cover front, side, rear, reflectors, and wiring.","prompt":"All headlights, high beams, turn signals, hazard lights, clearance lights, marker lights, tail lights, brake lights, and the license-plate light are the correct color, clean, securely mounted, not damaged, and operating properly. Reflectors and reflective tape are present and visible, and wiring is secure and insulated."},{"id":"quiz","label":"Lighting Check","desc":"Prove lighting knowledge.","type":"quiz","heading":"Complete the full lighting check.","questions":[["What five checks apply to each lamp?",["Color, cleanliness, security, damage, and operation","Fuel, oil, coolant, air, cargo","Height, width, length, weight, route"],0,"Use the same five checks consistently."],["How can brake lights be verified?",["Use an approved helper or verification method","Assume they work","Check only the switch"],0,"Lights must be verified externally."],["What should wiring be?",["Secure, insulated, and not damaged","Loose","Dragging"],0,"Damaged or loose wiring can cause failures."],["What should reflective tape be?",["Present, secure, clean, and visible","Painted over","Removed"],0,"Conspicuity devices must remain visible."],["Does a glowing bulb alone complete the inspection?",["No, condition and correct color also matter","Yes","Only during daylight"],0,"Operation is one part of the complete check."]]}],"reward":{"knowledge":8,"confidence":8,"safety":8,"next":"Complete Inspection Sequence"},"voiceChecks":[{"label":"front lights","terms":["headlight","high beam","turn"]},{"label":"side and rear lights","terms":["marker","tail","brake"]},{"label":"five checks","terms":["color","clean","secure","damage","working"]},{"label":"reflectors and wiring","terms":["reflector","wiring"]}]},
19:{"week":"WEEK 3 · READINESS","title":"Complete Inspection Sequence","summary":"Connect the entire vehicle inspection into one authoritative sequence from cab preparation through exterior walkaround and final checks.","time":"30–40 minutes","focus":"Build the full professional flow","coach":"Today is the bridge from learning to performance. Follow one route, recover calmly if you lose your place, and never let speed erase safety language.","steps":[{"id":"welcome","label":"Mission Brief","desc":"Set the full-sequence target.","type":"brief","heading":"Perform the inspection as one coherent system.","body":"You now know the major components. Today you will connect them into a single sequence: preparation, in-cab, safe start, air brakes, engine compartment, driver side, coupling, trailer, rear, passenger side, and final light check.","note":"Use the same route every practice session. Sequence is your memory system."},{"id":"learn","label":"Full Sequence","desc":"Use ten anchor points.","type":"cards","heading":"Move through the vehicle without competing routes.","body":"These anchors become your authoritative progression.","cards":[["1–2","Cab preparation and in-cab inspection."],["3","Safe start, gauges, warnings, and air-brake tests."],["4–5","Engine compartment and steer axle."],["6–7","Driver-side cab, drive axle, and coupling."],["8–9","Trailer side, axles, rear, and passenger side."],["10","Lights, final safety check, and completion."]]},{"id":"visual","label":"Sequence Anchors","desc":"Practice the complete route.","type":"components","heading":"Use each anchor as a recovery point.","body":"If interrupted, return to the last completed anchor instead of restarting randomly.","components":[["Anchor 1 · Cab Entry","Safety equipment, seat belt, visibility, controls."],["Anchor 2 · Start & Air","Safe start, gauges, warnings, air-brake procedure."],["Anchor 3 · Under Hood","Fluids, belts, hoses, mounted components, steering."],["Anchor 4 · Steer Axle","Suspension, brakes, tire, rim, lugs, hub."],["Anchor 5 · Driver Cab","Door, mirror, steps, tank, frame."],["Anchor 6 · Drive & Coupling","Drive axle, lines, fifth wheel, lock."],["Anchor 7 · Trailer Driver Side","Structure, landing gear, lights."],["Anchor 8 · Trailer Running Gear","Suspension, brakes, duals, seals, tandem pins."],["Anchor 9 · Rear & Passenger Side","Rear containment, visibility, return walk."],["Anchor 10 · Final Verification","Lights, hazards, brake lights, completion."]]},{"id":"voice","label":"Full-Sequence Voice Drill","desc":"Speak the complete route.","type":"voice","heading":"Practice progression, not every detail.","body":"Name the sequence anchors in order and include the safety purpose.","prompt":"I begin with the in-cab inspection, safe start, gauges, warning devices, and air-brake tests. I continue through the engine compartment, steering, steer suspension, brakes, and wheel end. I inspect the driver-side cab, drive axle, coupling system, trailer structure, trailer axles, rear, passenger side, and complete the inspection with a full light and safety verification."},{"id":"quiz","label":"Sequence Readiness Check","desc":"Prove full-flow knowledge.","type":"quiz","heading":"Complete the sequence check.","questions":[["What is the authoritative source for progression?",["One fixed inspection route","Whichever component is easiest","Random memory"],0,"One route prevents competing sequences."],["What should you do if interrupted?",["Return to the last completed anchor","Restart randomly","Skip the rest"],0,"Anchors support calm recovery."],["Where do air-brake tests belong?",["After safe start according to the official procedure","At the rear doors","During tire inspection"],0,"Air-brake testing is part of the cab/start sequence."],["What should speed never remove?",["Complete safety language and direct inspection","Background music","Vehicle paint"],0,"Accuracy and safety remain primary."],["What is Day 19 preparing you for?",["Timed full-performance practice","Fuel purchasing","Dispatch paperwork"],0,"The next missions test complete performance."]]}],"reward":{"knowledge":9,"confidence":10,"safety":9,"next":"Timed Mock Pre-Trip"},"voiceChecks":[{"label":"cab and air brakes","terms":["cab","air brake"]},{"label":"engine and steer axle","terms":["engine","steering","steer"]},{"label":"drive axle and coupling","terms":["drive","coupling","fifth"]},{"label":"trailer and final lights","terms":["trailer","rear","light"]}]},
20:{"week":"WEEK 3 · READINESS","title":"Timed Mock Pre-Trip","summary":"Perform a complete mock inspection within a professional 20–30 minute target while preserving accuracy, sequence, and safety language.","time":"20–30 minutes","focus":"Build professional pacing","coach":"Professional pacing is steady, not rushed. Keep moving, but pause long enough to identify the part and state a complete safety check.","steps":[{"id":"welcome","label":"Mission Brief","desc":"Set the timed-performance target.","type":"brief","heading":"Complete the full inspection under realistic pacing.","body":"Today you will perform the complete sequence with a 20–30 minute target. Skilled performance may eventually reach 15–20 minutes, but accuracy, safety, and completeness remain the priority.","note":"Do not chase a fast time at the expense of critical components or official procedure."},{"id":"learn","label":"Pacing Strategy","desc":"Use four pacing rules.","type":"cards","heading":"Move steadily without sacrificing completeness.","body":"Train the rhythm you want on test day.","cards":[["Start Controlled","Use the first minute to establish sequence and voice."],["Keep Moving","Avoid long silent gaps or repeated explanations."],["Protect Critical Items","Never rush steering, brakes, coupling, tires, or air-brake tests."],["Recover Efficiently","Return to the last anchor if you lose your place."]]},{"id":"visual","label":"Timed Checkpoints","desc":"Use target windows, not panic.","type":"components","heading":"Compare your progress to professional pacing.","body":"Truck layout and jurisdiction can change exact timing.","components":[["0–5 Minutes","Cab preparation, in-cab, safe start, begin air-brake sequence."],["5–10 Minutes","Complete air brakes and engine compartment."],["10–15 Minutes","Steer axle, driver cab area, drive axle."],["15–20 Minutes","Coupling and trailer driver side."],["20–25 Minutes","Trailer axles, rear, passenger side."],["25–30 Minutes","Lights, recovery of missed items, final verification."]]},{"id":"voice","label":"Timed Mock Voice Start","desc":"Begin the mock inspection aloud.","type":"voice","heading":"Use a confident opening and sequence declaration.","body":"Start the timer separately, then read this launch statement and complete the full inspection.","prompt":"I am beginning a complete pre-trip inspection using one consistent sequence. I will identify each safety-critical component, describe its condition and security, check for damage, wear, looseness, contamination, or leaks, and verify that this vehicle is safe to operate."},{"id":"quiz","label":"Pacing Coach Check","desc":"Prove professional pacing judgment.","type":"quiz","heading":"Complete the timed-practice check.","questions":[["What is the primary target window?",["20–30 minutes","Under 5 minutes","Over 90 minutes"],0,"The primary training target is 20–30 minutes."],["What should never be sacrificed for speed?",["Accuracy, safety, sequence, and completeness","A short pause","A consistent route"],0,"Fast but incomplete is not professional."],["Which systems deserve protected time?",["Steering, brakes, coupling, tires, and air brakes","Radio and cup holder","Paint and decals"],0,"Critical systems require complete checks."],["What should you do after losing your place?",["Return to the last completed anchor","Jump to a random part","End the inspection"],0,"Anchor-based recovery preserves progression."],["What does skilled 15–20 minute pacing mean?",["A future proficiency range, not permission to rush","The only acceptable time","A reason to skip components"],0,"Build accuracy before speed."]]}],"reward":{"knowledge":8,"confidence":10,"safety":9,"next":"Final Readiness Test"},"voiceChecks":[{"label":"consistent sequence","terms":["consistent","sequence"]},{"label":"critical components","terms":["safety","critical","component"]},{"label":"condition and security","terms":["condition","secure","security"]},{"label":"damage, wear, leaks","terms":["damage","wear","leak"]}]},
21:{"week":"WEEK 3 · FINAL","title":"Final Readiness Test","summary":"Complete the 21-day program with a cumulative knowledge check, full-sequence voice performance, and an exam-readiness decision.","time":"30–40 minutes","focus":"Prove complete pre-trip readiness","coach":"Today is not about perfection. It is about proving that your sequence, safety language, knowledge, and recovery habits are strong enough for focused final preparation.","steps":[{"id":"welcome","label":"Final Mission Brief","desc":"Set the readiness target.","type":"brief","heading":"Demonstrate the complete system.","body":"You will finish with a cumulative review covering engine, steering, suspension, brakes, wheels, coupling, trailer, cab, air brakes, lights, sequence, and pacing.","note":"Use the result to guide final practice. Always compare exact procedures and limits with the current official CDL manual."},{"id":"learn","label":"Readiness Standard","desc":"Know what readiness means.","type":"cards","heading":"Evaluate knowledge, sequence, voice, and safety.","body":"A strong result is balanced across all four dimensions.","cards":[["Knowledge","Correctly identify systems, defects, and inspection purpose."],["Sequence","Move through one authoritative route without major omissions."],["Voice","Use clear, complete, professional inspection language."],["Safety","Protect critical systems and use official procedures and limits."]]},{"id":"visual","label":"Final Review Domains","desc":"Review the full curriculum.","type":"components","heading":"Use weak areas to plan the next practice session.","body":"Readiness is a decision, not merely a completion badge.","components":[["Engine & Steering","Fluids, belts, hoses, mounted components, steering linkage."],["Suspension, Brakes & Wheels","Support, stopping, tires, rims, fasteners, seals."],["Cab & Air Brakes","Safety equipment, start-up, warnings, complete air-brake sequence."],["Coupling & Trailer","Lines, fifth wheel, lock, structure, landing gear, axles, rear."],["Lights & Visibility","All lamps, reflectors, tape, mirrors, windshield, wipers."],["Sequence & Pacing","One route, calm recovery, professional 20–30 minute target."]]},{"id":"voice","label":"Final Voice Performance","desc":"Deliver the readiness statement.","type":"voice","heading":"Speak confidently and completely.","body":"Summarize the full inspection purpose and sequence.","prompt":"I can perform a complete pre-trip inspection in one consistent sequence. I will verify the cab, warning devices, air brakes, engine, steering, suspension, brakes, wheels, coupling, trailer, lights, and safety equipment. I will identify defects using specific condition, security, damage, leakage, wear, adjustment, and contamination language, and I will follow the current official CDL procedure."},{"id":"quiz","label":"Final Readiness Test","desc":"Prove cumulative knowledge.","type":"quiz","heading":"Complete the final five-question readiness check.","questions":[["What is the best protection against missed components?",["One authoritative inspection sequence","Random order","Only memorizing part names"],0,"A consistent route supports complete performance."],["Which language is strongest?",["Specific condition, security, damage, leakage, wear, and adjustment checks","It looks fine","Probably okay"],0,"Professional language names the actual safety checks."],["Where do exact air-brake limits come from?",["The current official manual and jurisdiction procedure","A random social post","A product advertisement"],0,"Official limits must control the test."],["What should professional pacing prioritize?",["Accuracy, safety, completeness, and steady progression","Finishing as fast as possible","Skipping repeated systems"],0,"Pacing must never defeat safety."],["What should happen after the 21-day program?",["Use results to target weak areas and continue realistic practice","Stop practicing permanently","Ignore official procedures"],0,"Readiness improves through focused continued practice."]]}],"reward":{"knowledge":12,"confidence":12,"safety":12,"next":"Exam-Ready Practice"},"voiceChecks":[{"label":"consistent sequence","terms":["consistent","sequence"]},{"label":"major systems","terms":["engine","steering","suspension","brake","wheel","coupling","trailer"]},{"label":"specific defect language","terms":["damage","leak","wear","adjust","contamination"]},{"label":"official procedure","terms":["official","procedure"]}]}
};
function hasPlusAccess(){
  try{
    if(window.PreTripEntitlements&&typeof window.PreTripEntitlements.hasPlus==="function"){
      return window.PreTripEntitlements.hasPlus()===true;
    }
    if(
      window.preTripSubscriptionActive===true||
      window.PRETRIP_PLUS_ACTIVE===true||
      window.__PRETRIP_IQ_PLUS_ACTIVE__===true||
      (window.PreTripIQNative&&window.PreTripIQNative.isPremium===true)||
      (window.PreTripIQNative&&window.PreTripIQNative.entitlement&&window.PreTripIQNative.entitlement.active===true)
    ){return true;}
    var keys=[
      "pretrip_plus_active",
      "pretrip_subscription_active",
      "ptiq_plus_active",
      "ptiq_entitlement",
      "pretrip_iq_plus_active",
      "preTripIQPlusActive",
      "pretripIQPremium",
      "pretrip_iq_entitlement"
    ];
    for(var i=0;i<keys.length;i++){
      var raw=localStorage.getItem(keys[i]);
      if(raw==="true"||raw==="1"||raw==="plus"||raw==="active"){return true;}
      try{
        var parsed=JSON.parse(raw||"null");
        if(parsed&&(parsed.active===true||parsed.plan==="plus"||parsed.entitled===true)){return true;}
      }catch(e){}
    }
  }catch(e){}
  return false;
}

var PRETRIP_MONTHLY_PRODUCT_ID=String(
  window.PRETRIP_MONTHLY_PRODUCT_ID||
  window.PRE_TRIP_MONTHLY_PRODUCT_ID||
  ""
);
var PRETRIP_YEARLY_PRODUCT_ID=String(
  window.PRETRIP_YEARLY_PRODUCT_ID||
  window.PRE_TRIP_YEARLY_PRODUCT_ID||
  ""
);
var PTIQ_PENDING_UNLOCK_KEY="ptiq_pending_unlock_after_purchase_v1";
var PTIQ_PENDING_PURCHASE_EVENT_KEY="ptiq_pending_purchase_event_v1";
var PTIQ_LAST_STUDENT_OPEN_KEY="ptiq_founder_student_open_day_v1";
var PTIQ_FUNNEL_SESSION_FLAGS={};

function ptiqPostNative(name,payload){
  try{
    var handlers=window.webkit&&window.webkit.messageHandlers;
    var handler=handlers&&handlers[name];
    if(handler&&typeof handler.postMessage==="function"){
      handler.postMessage(payload);
      return true;
    }
  }catch(e){}
  return false;
}

function ptiqTrackSessionOnce(flag,eventName,payload){
  var key=String(flag||eventName||"");
  if(!key||PTIQ_FUNNEL_SESSION_FLAGS[key]){return false;}
  PTIQ_FUNNEL_SESSION_FLAGS[key]=true;
  return founderTrack(eventName,payload||{});
}

function ptiqTrackStudentOpenedOncePerDay(payload){
  var today=new Date().toISOString().slice(0,10);
  var last="";
  try{last=localStorage.getItem(PTIQ_LAST_STUDENT_OPEN_KEY)||"";}catch(e){}
  if(last===today){return false;}
  try{localStorage.setItem(PTIQ_LAST_STUDENT_OPEN_KEY,today);}catch(e){}
  return founderTrack("student_opened",payload||{});
}

function ptiqRememberPurchaseIntent(plan,source){
  var intent={
    plan:plan,
    source:source,
    day:typeof day!=="undefined"?day:null,
    at:Date.now()
  };
  try{
    localStorage.setItem(PTIQ_PENDING_PURCHASE_EVENT_KEY,JSON.stringify(intent));
  }catch(e){}
  return intent;
}

function ptiqReadPurchaseIntent(){
  try{
    return JSON.parse(localStorage.getItem(PTIQ_PENDING_PURCHASE_EVENT_KEY)||"null");
  }catch(e){
    return null;
  }
}

function ptiqClearPurchaseIntent(){
  try{localStorage.removeItem(PTIQ_PENDING_PURCHASE_EVENT_KEY);}catch(e){}
}

function ptiqTrackAppleSheetOpened(detail){
  var intent=ptiqReadPurchaseIntent()||{};
  detail=detail||{};
  ptiqTrackSessionOnce(
    "apple_sheet_opened_"+String(intent.plan||detail.plan||"unknown"),
    "apple_sheet_opened",
    {
      plan:String(detail.plan||intent.plan||""),
      source:String(detail.source||intent.source||"native_storekit"),
      day:Number(intent.day||day||0),
      detail:"Native StoreKit purchase sheet opened"
    }
  );
}

function ptiqOpenPlus(plan,source){
  plan=plan==="yearly"?"yearly":"monthly";
  source=source||"mission_gate";

  var productId=plan==="yearly"
    ?PRETRIP_YEARLY_PRODUCT_ID
    :PRETRIP_MONTHLY_PRODUCT_ID;

  var payload={
    action:"openPaywall",
    command:"purchase",
    plan:plan,
    productId:productId,
    product_id:productId,
    source:source,
    reason:"free_foundation_complete"
  };

  founderTrack("upgrade_tapped",{
    plan:plan,
    productId:productId,
    source:source,
    day:typeof day!=="undefined"?day:null
  });
  ptiqRememberPurchaseIntent(plan,source);

  try{localStorage.setItem(PTIQ_PENDING_UNLOCK_KEY,String(day||5));}catch(e){}

  var sent=
    ptiqPostNative("openPaywall",payload)||
    ptiqPostNative("paywall",payload)||
    ptiqPostNative("subscription",payload)||
    ptiqPostNative("iap",payload)||
    ptiqPostNative("storeKit",payload)||
    ptiqPostNative("nativeApp",payload)||
    ptiqPostNative("purchase",payload);

  try{
    window.dispatchEvent(new CustomEvent("pretrip:open-paywall",{detail:payload}));
    document.dispatchEvent(new CustomEvent("pretrip:open-paywall",{detail:payload}));
  }catch(e){}

  if(!sent){
    try{
      window.location.href="pretripiq://plus?plan="+encodeURIComponent(plan);
      return true;
    }catch(e){}
  }

  return sent;
}

function ptiqRestorePurchases(source){
  var payload={
    action:"restore",
    command:"restore",
    source:source||"mission_gate"
  };

  var sent=
    ptiqPostNative("restorePurchases",payload)||
    ptiqPostNative("subscription",payload)||
    ptiqPostNative("iap",payload)||
    ptiqPostNative("storeKit",payload)||
    ptiqPostNative("nativeApp",payload);

  try{
    window.dispatchEvent(new CustomEvent("pretrip:restore-purchases",{detail:payload}));
  }catch(e){}

  if(!sent){
    try{
      window.location.href="pretripiq://restore";
      return true;
    }catch(e){}
  }

  return sent;
}

function ptiqMarkPlusActive(){
  try{
    window.preTripSubscriptionActive=true;
    window.PRETRIP_PLUS_ACTIVE=true;
    window.__PRETRIP_IQ_PLUS_ACTIVE__=true;
    window.PreTripIQNative=window.PreTripIQNative||{};
    window.PreTripIQNative.isPremium=true;
    localStorage.setItem("pretrip_plus_active","true");
    localStorage.setItem("pretrip_subscription_active","true");
    localStorage.setItem("ptiq_plus_active","true");
    localStorage.setItem("pretrip_iq_plus_active","true");
    localStorage.setItem("preTripIQPlusActive","true");
    localStorage.setItem("pretripIQPremium","true");
    localStorage.setItem("ptiq_entitlement",JSON.stringify({
      active:true,
      entitled:true,
      plan:"plus",
      updatedAt:new Date().toISOString()
    }));
  }catch(e){}
}

var ptiqEntitlementApplied=false;
var ptiqUnlockTransitionHandled=false;

function ptiqHandleEntitlement(active){
  active=active===true||
    active==="true"||
    active===1||
    (active&&(
      active.active===true||
      active.isActive===true||
      active.isPremium===true||
      active.hasEntitlement===true||
      active.entitled===true||
      active.success===true||
      active.purchased===true||
      active.status==="active"||
      active.status==="success"||
      active.status==="restored"
    ));

  if(!active){
    var failedStatus=document.querySelector("[data-ptiq-paywall-status]");
    if(failedStatus){
      failedStatus.textContent="The subscription was not completed. You can try again or restore purchases.";
    }

    var failedIntent=ptiqReadPurchaseIntent();
    if(failedIntent){
      founderTrack("purchase_error",{
        plan:String(failedIntent.plan||""),
        source:String(failedIntent.source||"mission_gate"),
        day:Number(failedIntent.day||day||0),
        detail:"Native purchase returned without an active entitlement"
      });
      ptiqClearPurchaseIntent();
    }
    return false;
  }

  /*
    Native publishes the same active entitlement through several callbacks
    and events. Applying it must be idempotent. Never reload an already-open
    free mission merely because entitlement status was republished; doing so
    creates a page-load -> entitlement -> reload loop.
  */
  var wasLocked=typeof locked!=="undefined"&&locked===true;
  var purchaseIntent=ptiqReadPurchaseIntent();

  ptiqMarkPlusActive();
  ptiqEntitlementApplied=true;

  if(purchaseIntent){
    founderTrack("subscription_started",{
      plan:String(purchaseIntent.plan||""),
      source:String(purchaseIntent.source||"mission_gate"),
      day:Number(purchaseIntent.day||day||0),
      detail:"Premium entitlement became active after purchase intent"
    });
    ptiqClearPurchaseIntent();
  }

  try{localStorage.removeItem(PTIQ_PENDING_UNLOCK_KEY);}catch(e){}

  var status=document.querySelector("[data-ptiq-paywall-status]");
  if(status){
    status.textContent="Pre-Trip IQ Plus unlocked. Opening your mission…";
  }

  /* Free missions 1-4 are already open. Do not reload them. */
  if(typeof day!=="undefined"&&day<=4){
    if(day===4&&typeof finishMission==="function"&&typeof isComplete==="function"&&isComplete()){
      finishMission();
    }
    return true;
  }

  /* Only reload once when an actually locked paid mission becomes unlocked. */
  if(wasLocked&&!ptiqUnlockTransitionHandled){
    ptiqUnlockTransitionHandled=true;
    window.setTimeout(function(){
      window.location.reload();
    },150);
  }

  return true;
}

function ptiqBuildLockedPaywall(panel){
  if(!panel){return;}

  panel.hidden=false;
  ptiqTrackSessionOnce(
    "upgrade_viewed_locked_"+String(day),
    "upgrade_viewed",
    {
      day:day,
      source:"locked_mission_"+day,
      gate:"mission_lock",
      plans:["monthly","yearly"]
    }
  );
  panel.innerHTML=
    '<div class="ptiq-mission-paywall-card">'+
      '<span class="ptiq-mission-kicker">PRE-TRIP IQ PLUS</span>'+
      '<h2>Unlock Missions 5–21</h2>'+
      '<p>Your free four-mission Foundation is complete. Continue with brakes, wheels, coupling, trailer, in-cab, air brakes, timed practice, and final readiness.</p>'+
      '<div class="ptiq-mission-paywall-actions">'+
        '<button type="button" class="ptiq-mission-btn ptiq-mission-btn--primary" data-ptiq-upgrade-monthly>UPGRADE MONTHLY <span>→</span></button>'+
        '<button type="button" class="ptiq-mission-btn ptiq-mission-btn--primary" data-ptiq-upgrade-yearly>UPGRADE YEARLY · BEST VALUE <span>→</span></button>'+
        '<button type="button" class="ptiq-mission-btn ptiq-mission-btn--secondary" data-ptiq-restore>Restore Purchases</button>'+
        '<a class="ptiq-mission-btn ptiq-mission-btn--secondary" href="'+URLS.dashboard+'">Return to Dashboard</a>'+
      '</div>'+
      '<div data-ptiq-paywall-status aria-live="polite" style="min-height:20px;margin-top:12px;text-align:center;opacity:.78;font-size:13px"></div>'+
    '</div>';

  var monthly=panel.querySelector("[data-ptiq-upgrade-monthly]");
  var yearly=panel.querySelector("[data-ptiq-upgrade-yearly]");
  var restore=panel.querySelector("[data-ptiq-restore]");
  var status=panel.querySelector("[data-ptiq-paywall-status]");

  if(monthly){
    monthly.addEventListener("click",function(){
      if(status){status.textContent="Opening Apple monthly subscription…";}
      ptiqOpenPlus("monthly","locked_mission_"+day);
    });
  }

  if(yearly){
    yearly.addEventListener("click",function(){
      if(status){status.textContent="Opening Apple yearly subscription…";}
      ptiqOpenPlus("yearly","locked_mission_"+day);
    });
  }

  if(restore){
    restore.addEventListener("click",function(){
      if(status){status.textContent="Checking your Apple purchases…";}
      ptiqRestorePurchases("locked_mission_"+day);
    });
  }
}

try{
  window.PreTripSubscriptionResult=function(result){
    ptiqHandleEntitlement(result);
  };

  window.PreTripRestoreResult=function(result){
    var restored=result===true||
      (result&&(
        result.active===true||
        result.isActive===true||
        result.isPremium===true||
        result.entitled===true||
        result.status==="restored"||
        result.status==="active"
      ));

    founderTrack("restore_completed",{
      active:restored===true,
      source:"native_restore_callback"
    });

    ptiqHandleEntitlement(result);
  };

  // Current native shell callbacks.
  window.PreTripIQPurchaseResult=function(result){
    ptiqHandleEntitlement(result);
  };

  window.PreTripIQEntitlementStatus=function(result){
    ptiqHandleEntitlement(result);
  };

  window.preTripIQEntitlementStatus=function(result){
    ptiqHandleEntitlement(result);
  };

  // Native should call this immediately before/when StoreKit presents the Apple sheet.
  window.PreTripIQAppleSheetOpened=function(detail){
    ptiqTrackAppleSheetOpened(detail||{});
  };

  window.preTripIQAppleSheetOpened=window.PreTripIQAppleSheetOpened;

  // Legacy and current entitlement events.
  window.addEventListener("pretrip:plus-entitlement-changed",function(event){
    ptiqHandleEntitlement(event&&event.detail?event.detail:false);
  });

  window.addEventListener("ptiq:plus-entitlement-changed",function(event){
    ptiqHandleEntitlement(event&&event.detail?event.detail:false);
  });

  window.addEventListener("preTripIQEntitlementChanged",function(event){
    ptiqHandleEntitlement(event&&event.detail?event.detail:false);
  });

  window.addEventListener("preTripIQEntitlementStatus",function(event){
    ptiqHandleEntitlement(event&&event.detail?event.detail:false);
  });

  window.addEventListener("preTripIQPurchaseResult",function(event){
    ptiqHandleEntitlement(event&&event.detail?event.detail:false);
  });

  window.addEventListener("pretrip:apple-sheet-opened",function(event){
    ptiqTrackAppleSheetOpened(event&&event.detail?event.detail:{});
  });

  window.addEventListener("ptiq:apple-sheet-opened",function(event){
    ptiqTrackAppleSheetOpened(event&&event.detail?event.detail:{});
  });
}catch(e){}
var params=new URLSearchParams(window.location.search);var day=Math.max(1,Math.min(21,Number(params.get("day")||1)));var locked=day>4&&!hasPlusAccess();var mission=locked?null:MISSIONS[day];var completedKey="ptiq21_completed_days_v1";var missionKey="ptiq21_mission_"+day+"_steps_v2";var state=readJSON(missionKey,{});var completedDays=readJSON(completedKey,[]);var recognition=null;
var FOUNDER_STATE_KEY="pretrip_founder_iq_v1";
var FOUNDER_EVENTS_KEY="pretrip_founder_iq_events_v1";

var FOUNDER_API_URL="https://pre-trip-founder-iq-api-85238371012.us-central1.run.app";
var FOUNDER_INGEST_KEY="";
var FOUNDER_QUEUE_KEY="pretrip_founder_iq_upload_queue_v1";
var FOUNDER_DEVICE_KEY="pretrip_founder_iq_device_id_v1";
var FOUNDER_ALLOWED_EVENTS={
  student_opened:true,
  study_started:true,
  parts_started:true,
  voice_started:true,
  voice_completed:true,
  inspection_started:true,
  inspection_completed:true,
  practice_test_started:true,
  practice_test_completed:true,
  mock_exam_completed:true,
  readiness_opened:true,
  upgrade_viewed:true,
  upgrade_tapped:true,
  apple_sheet_opened:true,
  subscription_started:true,
  restore_completed:true,
  microphone_error:true,
  voice_recognition_error:true,
  voice_recognition_recovered:true,
  coach_response_played:true,
  coach_retry_requested:true,
  coach_retry_completed:true,
  coach_advance:true,
  voice_timeout:true,
  voice_abandon:true,
  purchase_error:true,
  review_prompt:true,
  review_accepted:true,
  feedback_received:true,
  progression_nudge_shown:true,
  progression_nudge_tapped:true,
  progression_step_advanced:true,
  coach_guidance_spoken:true,
  coach_audio_toggled:true,
  quiz_results_coached:true,
  stage_transition_coached:true
  ,voice_screen_viewed:true
  ,voice_example_played:true
  ,voice_your_turn_tapped:true
  ,voice_recognition_started:true
  ,voice_response_received:true
  ,voice_feedback_played:true
  ,voice_item_completed:true
  ,inspection_cta_shown:true
  ,inspection_cta_tapped:true
};

function founderCanonicalEvent(eventName,payload){
  var name=String(eventName||"").trim();
  payload=payload||{};

  if(FOUNDER_ALLOWED_EVENTS[name]){return name;}
  if(name==="mission_started"){return "study_started";}
  if(name==="practice_test_attempted"){return "practice_test_started";}
  if(name==="parts_completed"){return "";}
  if(name==="study_completed"){return "";}
  if(name==="mission_completed"){
    if(Number(payload.day)===20){return "mock_exam_completed";}
    if(Number(payload.day)===21){return "readiness_opened";}
    if(Number(payload.day)>=19){return "inspection_completed";}
    return "";
  }
  return "";
}

function founderDeviceId(){
  var id="";
  try{id=localStorage.getItem(FOUNDER_DEVICE_KEY)||"";}catch(e){}
  if(!id){
    id="ptiq_"+Date.now().toString(36)+"_"+Math.random().toString(36).slice(2,12);
    try{localStorage.setItem(FOUNDER_DEVICE_KEY,id);}catch(e){}
  }
  return id;
}

function founderQueue(record){
  try{
    var queue=readJSON(FOUNDER_QUEUE_KEY,[]);
    if(!Array.isArray(queue)){queue=[];}
    queue.push(record);
    queue=queue.slice(-500);
    localStorage.setItem(FOUNDER_QUEUE_KEY,JSON.stringify(queue));
  }catch(e){}
}

function founderSend(record){
  var canonical=founderCanonicalEvent(record&&record.event,record&&record.payload);
  if(!canonical){return Promise.resolve(true);}

  var uploadRecord={
    id:record.id,
    app:"pretrip_iq",
    event:canonical,
    eventName:canonical,
    occurredAt:record.occurredAt,
    at:record.at,
    day:record.day,
    missionTitle:record.missionTitle,
    sessionId:record.sessionId,
    deviceId:record.deviceId,
    userId:record.userId,
    appVersion:String(window.PRE_TRIP_IQ_MISSION_BUILD||""),
    platform:"ios",
    payload:Object.assign({},record.payload||{},{
      sourceEvent:String(record.event||""),
      source:"mission_asset"
    })
  };

  if(!FOUNDER_API_URL){
    founderQueue(uploadRecord);
    return Promise.resolve(false);
  }

  return fetch(FOUNDER_API_URL+"/events",{
    method:"POST",
    mode:"cors",
    credentials:"omit",
    keepalive:true,
    headers:{
      "Content-Type":"application/json"
    },
    body:JSON.stringify(uploadRecord)
  }).then(function(response){
    if(!response.ok){
      throw new Error("Founder IQ upload failed with status "+response.status);
    }
    return true;
  }).catch(function(error){
    console.warn("Founder IQ event queued:",error);
    founderQueue(uploadRecord);
    return false;
  });
}

function founderFlushQueue(){
  if(!FOUNDER_API_URL){return Promise.resolve(false);}

  var queue=[];
  try{
    queue=readJSON(FOUNDER_QUEUE_KEY,[]);
    if(!Array.isArray(queue)||!queue.length){return Promise.resolve(true);}
  }catch(e){
    return Promise.resolve(false);
  }

  var pending=queue.slice(0,50);
  return fetch(FOUNDER_API_URL+"/events/batch",{
    method:"POST",
    mode:"cors",
    keepalive:true,
    headers:{
      "Content-Type":"application/json"
    },
    body:JSON.stringify({events:pending})
  }).then(function(response){
    if(!response.ok){
      throw new Error("Founder IQ batch upload failed with status "+response.status);
    }
    var remaining=queue.slice(pending.length);
    localStorage.setItem(FOUNDER_QUEUE_KEY,JSON.stringify(remaining));
    if(remaining.length){window.setTimeout(founderFlushQueue,500);}
    return true;
  }).catch(function(error){
    console.warn("Founder IQ queue remains pending:",error);
    return false;
  });
}

window.addEventListener("online",founderFlushQueue);
window.setTimeout(founderFlushQueue,1200);


var founderPageSessionId="mission_"+day+"_"+Date.now().toString(36)+"_"+Math.random().toString(36).slice(2,9);
var founderStudyStartedThisPage=false;
var founderMissionStartedAt=0;
var voiceAttempt={
  started:false,
  completed:false,
  transcript:"",
  score:null,
  startedAt:0,
  attemptCount:0,
  retryCount:0,
  accepted:false,
  lastMissed:[],
  lastCoachText:"",
  recognitionErrors:0,
  recoveryCount:0,
  autoAdvanced:false,
  demoPlayed:false,
  responseReceived:false
};
var VOICE_ITEMS_KEY="ptiq_voice_items_completed_v1";
var voiceCoachState="ready";
var voiceCoachRestartTimer=null;
var voiceRecognitionSilenceTimer=null;
var voiceRecognitionHardStopTimer=null;
var voiceCoachSpeechTimer=null;
var voiceCoachSpeaking=false;
var voiceRecognitionGeneration=0;

/* =========================================================
   V9 GUIDED COACH JOURNEY
   Written guidance is always authoritative. Audio is an
   optional spoken layer used only at high-value moments.
========================================================= */
var COACH_AUDIO_KEY="ptiq_voice_coach_audio_v1";
var coachAudioEnabled=(function(){
  try{return localStorage.getItem(COACH_AUDIO_KEY)!=="0";}catch(e){return true;}
})();
var coachGlobalSpeaking=false;

function coachAudioIsOn(){
  return coachAudioEnabled===true;
}

function coachSetAudio(enabled,source){
  coachAudioEnabled=enabled===true;
  try{localStorage.setItem(COACH_AUDIO_KEY,coachAudioEnabled?"1":"0");}catch(e){}
  qa("[data-coach-audio-toggle]").forEach(function(button){
    button.setAttribute("aria-pressed",coachAudioEnabled?"true":"false");
    button.setAttribute("aria-label",coachAudioEnabled?"Mute Voice Coach":"Turn Voice Coach audio on");
    button.innerHTML=coachAudioEnabled
      ?'<span aria-hidden="true">🔊</span><b>Coach On</b>'
      :'<span aria-hidden="true">🔇</span><b>Coach Off</b>';
    button.classList.toggle("is-muted",!coachAudioEnabled);
  });
  if(String(source||"")!=="render"){
    founderTrack("coach_audio_toggled",{
      day:day,
      missionTitle:mission?mission.title:"",
      enabled:coachAudioEnabled,
      source:String(source||"audio_toggle")
    });
  }
  if(!coachAudioEnabled){
    try{if(window.speechSynthesis){window.speechSynthesis.cancel();}}catch(e){}
    coachGlobalSpeaking=false;
    voiceCoachSpeaking=false;
  }
  return coachAudioEnabled;
}

function renderCoachAudioControl(){
  if(!mission||q("[data-coach-audio-toggle]")){return;}
  var button=document.createElement("button");
  button.type="button";
  button.className="ptiq-coach-audio-toggle";
  button.setAttribute("data-coach-audio-toggle","");
  button.setAttribute("aria-live","polite");
  root.appendChild(button);
  coachSetAudio(coachAudioEnabled,"render");
  /* Do not count the initial render as a user preference change. */
  button.addEventListener("click",function(){
    coachSetAudio(!coachAudioEnabled,"student_toggle");
  });
}

/* =========================================================
   V10 NATURAL VOICE COACH
   Written feedback stays authoritative. Spoken coaching gets
   a separate speech-optimized delivery layer and the best
   available English voice on the device.
========================================================= */
var coachPreferredVoice=null;
function coachVoiceScore(voice){
  if(!voice){return -9999;}
  var name=String(voice.name||"").toLowerCase(),lang=String(voice.lang||"").toLowerCase(),score=0;
  if(lang==="en-us"){score+=80;}else if(lang.indexOf("en-")===0){score+=45;}else if(lang.indexOf("en")===0){score+=25;}
  if(voice.localService){score+=10;}
  ["ava","samantha","zoe","allison","susan","tom","daniel","serena","karen","moira","rishi"].forEach(function(v,i){if(name.indexOf(v)!==-1){score+=Math.max(8,34-i);}});
  if(/premium|enhanced|natural|neural/.test(name)){score+=55;}
  if(/bad news|good news|bells|boing|bubbles|cellos|jester|organ|superstar|trinoids|whisper|zarvox/.test(name)){score-=120;}
  return score;
}
function coachRefreshPreferredVoice(){
  if(!window.speechSynthesis){return null;}
  var voices=[];try{voices=window.speechSynthesis.getVoices()||[];}catch(e){}
  if(voices.length){coachPreferredVoice=voices.slice().sort(function(a,b){return coachVoiceScore(b)-coachVoiceScore(a);})[0]||null;}
  return coachPreferredVoice;
}
if(window.speechSynthesis){
  coachRefreshPreferredVoice();
  if(typeof window.speechSynthesis.addEventListener==="function"){window.speechSynthesis.addEventListener("voiceschanged",coachRefreshPreferredVoice);}
  else{window.speechSynthesis.onvoiceschanged=coachRefreshPreferredVoice;}
  window.setTimeout(coachRefreshPreferredVoice,250);window.setTimeout(coachRefreshPreferredVoice,900);
}
function coachSpeechText(text){
  var line=String(text||"").replace(/\s+/g," ").trim();if(!line){return "";}
  return line.replace(/\s*—\s*/g,", ").replace(/\bNext:\s*/gi,"Next, ").replace(/\bUse this wording:\s*/gi,"Say it like this. ").replace(/\bThe missing piece is\s+/gi,"One thing to add is ").replace(/\bI did not\b/g,"I didn't").replace(/\bYou are\b/g,"You're").replace(/\bThat is\b/g,"That's").replace(/\bDo not\b/g,"Don't").replace(/\s+([,.!?])/g,"$1").replace(/([.!?])(?=[A-Z])/g,"$1 ").replace(/\s+/g," ").trim();
}
function coachCreateUtterance(text,options){
  options=options||{};var spoken=coachSpeechText(text);if(!spoken||!window.SpeechSynthesisUtterance){return null;}
  var utterance=new SpeechSynthesisUtterance(spoken),voice=coachRefreshPreferredVoice();
  if(voice){utterance.voice=voice;utterance.lang=voice.lang||"en-US";}else{utterance.lang="en-US";}
  utterance.rate=Number(options.rate||0.91);utterance.pitch=Number(options.pitch||0.98);utterance.volume=1.0;return utterance;
}

function coachCanAutoSpeak(){
  return !!(
    coachAudioEnabled &&
    window.speechSynthesis &&
    window.SpeechSynthesisUtterance
  );
}

function coachSpeakGlobal(textToSpeak,options){
  options=options||{};
  var line=String(textToSpeak||"").replace(/\s+/g," ").trim();
  if(!line){return false;}
  if(!coachAudioEnabled&&options.forceAudio!==true){return false;}
  if(!window.speechSynthesis||!window.SpeechSynthesisUtterance){return false;}
  if(voiceCoachState==="listening"||voiceCoachState==="checking"){return false;}

  try{window.speechSynthesis.cancel();}catch(e){}
  coachGlobalSpeaking=true;

  try{
    var utterance=coachCreateUtterance(line,options);
    if(!utterance){coachGlobalSpeaking=false;return false;}
    var finish=function(){coachGlobalSpeaking=false;};
    utterance.onend=finish;
    utterance.onerror=finish;
    window.speechSynthesis.speak(utterance);
    founderTrack("coach_guidance_spoken",{
      day:day,
      missionTitle:mission?mission.title:"",
      kind:String(options.kind||"guidance"),
      detail:line.slice(0,220)
    });
    return true;
  }catch(e){
    coachGlobalSpeaking=false;
    return false;
  }
}

function coachStageTransitionLine(completedStep,nextStep){
  if(!nextStep){return "";}
  var nextLabel=String(nextStep.label||nextStep.heading||"the next section").replace(/\s+/g," ").trim();
  var type=String(nextStep.type||"");
  if(type==="voice"){
    return "Good work. Next, Voice Coach. Let's say this section out loud.";
  }
  if(type==="quiz"){
    return "Nice work. Next, check what you remember in the Knowledge Check.";
  }
  if(type==="partsChallenge"){
    return "Good. Next, Parts IQ. Let's make sure you can recognize the components and the checks that go with them.";
  }
  return "Good. Next, "+nextLabel+".";
}

function coachMissionNextLine(){
  if(day===21){
    return "You finished the 21-day mission. Next, open your Readiness Dashboard and use the results to target what needs another repetition.";
  }
  if(day===4&&!hasPlusAccess()){
    return "Foundation complete. When you're ready, unlock the complete system and continue with Brake System.";
  }
  return "Day "+day+" complete. Next up, "+String(mission&&mission.reward?mission.reward.next:"Mission "+(day+1))+".";
}

function installPaywallButtonFix(){
  if(document.getElementById("ptiq-paywall-button-fix")){return;}
  var style=document.createElement("style");
  style.id="ptiq-paywall-button-fix";
  style.textContent=
    "[data-paywall-panel] .ptiq-mission-paywall-actions{display:grid;gap:12px;margin-top:22px}"+
    "[data-paywall-panel] button.ptiq-mission-btn{width:100%;border:0;cursor:pointer;font:inherit}"+
    "[data-paywall-panel] [data-ptiq-upgrade-yearly]{background:linear-gradient(135deg,#ffe078,#55e8d0)!important;color:#082029!important}"+
    "[data-paywall-panel] .ptiq-mission-paywall-card{max-width:620px;margin:0 auto;padding:28px;border-radius:28px;background:rgba(8,25,34,.96);border:1px solid rgba(255,255,255,.1)}";
  document.head.appendChild(style);
}
installPaywallButtonFix();

function installMissionPolish(){
  if(document.getElementById("ptiq-mission-polish-v2")){return;}
  var style=document.createElement("style");
  style.id="ptiq-mission-polish-v2";
  style.textContent=[
    ".ptiq-mission-quicknav{display:flex;align-items:center;justify-content:space-between;gap:12px;margin:18px 0 8px;padding:12px;border:1px solid rgba(255,255,255,.1);border-radius:18px;background:rgba(7,22,31,.72);backdrop-filter:blur(14px)}",
    ".ptiq-mission-quicknav__center{min-width:0;text-align:center}.ptiq-mission-quicknav__center small{display:block;opacity:.62;font-size:10px;letter-spacing:.14em}.ptiq-mission-quicknav__center strong{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}",
    ".ptiq-mission-quicknav a[aria-disabled=true]{pointer-events:none;opacity:.32}",
    ".ptiq-mission-resume{margin:14px 0;padding:14px 16px;border-radius:16px;border:1px solid rgba(71,220,255,.24);background:rgba(71,220,255,.08)}",
    ".ptiq-mission-resume strong{display:block;margin-bottom:4px}.ptiq-mission-resume span{opacity:.78}",
    ".ptiq-mission-stage.is-locked-step{opacity:.58}.ptiq-mission-stage.is-active{scroll-margin-top:94px}",
    ".ptiq-mission-quiz label.is-correct{outline:1px solid rgba(64,220,151,.6);background:rgba(64,220,151,.09)}",
    ".ptiq-mission-quiz label.is-wrong{outline:1px solid rgba(255,104,104,.62);background:rgba(255,104,104,.09)}",
    ".ptiq-readiness-summary{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px;margin:18px 0}",
    ".ptiq-readiness-summary article{padding:14px;border-radius:16px;background:rgba(255,255,255,.055);border:1px solid rgba(255,255,255,.08);text-align:center}",
    ".ptiq-readiness-summary small{display:block;opacity:.6;font-size:10px;letter-spacing:.12em}.ptiq-readiness-summary strong{font-size:22px}",
    ".ptiq-coach-audio-toggle{position:fixed;right:14px;top:calc(env(safe-area-inset-top,0px) + 72px);z-index:2147482000;display:flex;align-items:center;gap:7px;padding:9px 11px;border-radius:999px;border:1px solid rgba(83,235,212,.26);background:rgba(7,25,34,.92);color:#ecfbf8;box-shadow:0 10px 28px rgba(0,0,0,.25);backdrop-filter:blur(14px);font:inherit;font-size:12px;font-weight:900;cursor:pointer}",
    ".ptiq-coach-audio-toggle.is-muted{opacity:.7;border-color:rgba(255,255,255,.12)}",
    ".ptiq-coach-audio-toggle span{font-size:15px}.ptiq-coach-audio-toggle b{white-space:nowrap}",
    "@media(max-width:640px){.ptiq-mission-quicknav{gap:7px}.ptiq-mission-quicknav .ptiq-mission-btn{padding:10px 11px}.ptiq-readiness-summary{grid-template-columns:1fr}.ptiq-coach-audio-toggle{right:10px;top:calc(env(safe-area-inset-top,0px) + 66px);padding:8px 10px}.ptiq-coach-audio-toggle b{font-size:11px}}"
  ].join("");
  document.head.appendChild(style);
}
installMissionPolish();

function installActiveVoiceCoachPolish(){
  if(document.getElementById("ptiq-active-voice-coach-v7")){return;}
  var style=document.createElement("style");
  style.id="ptiq-active-voice-coach-v7";
  style.textContent=[
    "[data-voice-state]{color:#68f2df;font-weight:950}",
    ".ptiq-mission-mic[data-voice-state=coaching]{pointer-events:none}",
    ".ptiq-mission-voice-feedback{min-height:70px}",
    "[data-mic-title]{display:block}",
    "[data-mic-subtitle]{display:block;max-width:190px;text-align:center;line-height:1.35}"
  ].join("");
  document.head.appendChild(style);
}
installActiveVoiceCoachPolish();


function installProgressionCoachPolish(){
  if(document.getElementById("ptiq-progression-coach-polish")){return;}
  var style=document.createElement("style");
  style.id="ptiq-progression-coach-polish";
  style.textContent=[
    ".ptiq-progression-coach{margin:18px 0;padding:16px 17px;border-radius:18px;border:1px solid rgba(83,235,212,.18);background:linear-gradient(135deg,rgba(20,108,111,.18),rgba(20,42,70,.42));box-shadow:0 14px 34px rgba(0,0,0,.16)}",
    ".ptiq-progression-coach small{display:block;margin-bottom:6px;color:#65eadb;font-size:10px;letter-spacing:.14em;font-weight:900}",
    ".ptiq-progression-coach strong{display:block;color:#f5f8fb;font-size:18px;line-height:1.25}",
    ".ptiq-progression-coach p{margin:7px 0 0;color:#adc0cc;font-size:13px;line-height:1.55}",
    ".ptiq-progression-coach__actions{display:flex;gap:9px;flex-wrap:wrap;margin-top:13px}",
    ".ptiq-mission-stage.is-active .ptiq-mission-stage__content{box-shadow:0 0 0 1px rgba(83,235,212,.08),0 18px 42px rgba(0,0,0,.14)}",
    ".ptiq-mission-stage.is-active .ptiq-mission-kicker:before{content:'NEXT · ';color:#5fe0ce;font-weight:900}",
    "@media(max-width:640px){.ptiq-progression-coach__actions .ptiq-mission-btn{width:100%;justify-content:center}}"
  ].join("");
  document.head.appendChild(style);
}
installProgressionCoachPolish();

function progressionStageLabel(step){
  if(!step){return "Continue";}
  if(step.type==="voice"){return "Start Voice Coach";}
  if(step.type==="quiz"){return "Take Knowledge Check";}
  if(step.type==="partsChallenge"){return "Start Parts IQ";}
  if(step.id==="visual"){return "Practice the Components";}
  if(step.id==="learn"){return "Continue Learning";}
  return "Continue to "+String(step.label||"Next Step");
}

function progressionTarget(){
  /*
    Mission study is the launchpad. The external recommendation changes as
    the student advances through the 21-day curriculum instead of treating
    every training tool as one strict funnel.
  */
  if(day<=6){
    return {
      key:"voice",
      href:URLS.voice,
      label:"Practice with Voice Coach",
      title:"Turn what you learned into spoken inspection language.",
      reason:"Speaking the checks out loud builds recall and test-day confidence."
    };
  }
  if(day<=14){
    return {
      key:"practice",
      href:URLS.practice,
      label:"Practice What You Learned",
      title:"Move from studying into active practice.",
      reason:"A short practice session now helps convert recognition into recall."
    };
  }
  if(day<=18){
    return {
      key:"inspection",
      href:URLS.inspection,
      label:"Start Guided Inspection",
      title:"You know the systems. Now connect them into a real inspection.",
      reason:"Guided inspection practice is the bridge between knowledge and performance."
    };
  }
  if(day===19){
    return {
      key:"practice",
      href:URLS.practice,
      label:"Run a Practice Test",
      title:"Test the complete sequence while it is fresh.",
      reason:"Use active recall before moving into timed performance."
    };
  }
  if(day===20){
    return {
      key:"readiness",
      href:URLS.dashboard,
      label:"Check My Readiness",
      title:"Your timed practice is complete.",
      reason:"Review your progress and identify the next weak area to train."
    };
  }
  return {
    key:"readiness",
    href:URLS.dashboard,
    label:"View My Readiness",
    title:"Use your results to guide the next practice session.",
    reason:"Readiness is maintained through targeted repetition, not one final score."
  };
}

function progressionCoachHTML(source){
  var target=progressionTarget();
  return '<div class="ptiq-progression-coach" data-progression-coach="'+esc(source||"mission")+'">'+
    '<small>NEXT BEST TRAINING ACTION</small>'+
    '<strong>'+esc(target.title)+'</strong>'+
    '<p>'+esc(target.reason)+'</p>'+
    '<div class="ptiq-progression-coach__actions">'+
      '<a class="ptiq-mission-btn ptiq-mission-btn--primary" data-progression-action="'+esc(target.key)+'" href="'+target.href+'">'+esc(target.label)+' <span>→</span></a>'+
      '<a class="ptiq-mission-btn ptiq-mission-btn--secondary" href="'+URLS.dashboard+'">Training Dashboard</a>'+
    '</div>'+
  '</div>';
}

function bindProgressionCoach(scope,source){
  scope=scope||root;
  var coach=scope.querySelector?scope.querySelector("[data-progression-coach]"):null;
  if(!coach){return;}
  var target=progressionTarget();
  ptiqTrackSessionOnce(
    "progression_nudge_shown_"+String(source||"mission")+"_"+String(day),
    "progression_nudge_shown",
    {
      day:day,
      missionTitle:mission?mission.title:"",
      target:target.key,
      source:String(source||"mission"),
      version:PTIQ_PROGRESS_VERSION
    }
  );
  var action=coach.querySelector("[data-progression-action]");
  if(action&&!action.__ptiqProgressBound){
    action.__ptiqProgressBound=true;
    action.addEventListener("click",function(){
      founderTrack("progression_nudge_tapped",{
        day:day,
        missionTitle:mission?mission.title:"",
        target:target.key,
        href:target.href,
        source:String(source||"mission"),
        version:PTIQ_PROGRESS_VERSION
      });
    });
  }
}

function firstIncompleteStep(){
  if(!mission){return null;}
  for(var i=0;i<mission.steps.length;i++){
    if(state[mission.steps[i].id]!==true){return mission.steps[i];}
  }
  return null;
}
function completedStepCount(){
  if(!mission){return 0;}
  return mission.steps.filter(function(step){return state[step.id]===true;}).length;
}
function missionHref(n){return "/pages/pre-trip-mission?day="+n;}
function renderQuickNav(){
  if(!mission){return;}
  var stages=q("[data-stages]");
  if(!stages||q("[data-mission-quicknav]")){return;}
  var prev=Math.max(1,day-1),next=Math.min(21,day+1);
  var nav=document.createElement("nav");
  nav.className="ptiq-mission-quicknav";
  nav.setAttribute("data-mission-quicknav","");
  nav.setAttribute("aria-label","Mission navigation");
  nav.innerHTML=
    '<a class="ptiq-mission-btn ptiq-mission-btn--secondary" '+(day===1?'aria-disabled="true"':'href="'+missionHref(prev)+'"')+'>← Day '+prev+'</a>'+
    '<div class="ptiq-mission-quicknav__center"><small>21-DAY PROGRAM</small><strong>Day '+day+' · '+esc(mission.title)+'</strong></div>'+
    '<a class="ptiq-mission-btn ptiq-mission-btn--secondary" '+(day===21?'aria-disabled="true"':'href="'+missionHref(next)+'"')+'>Day '+next+' →</a>';
  stages.parentNode.insertBefore(nav,stages);
}
function renderResumeCue(){
  if(!mission){return;}
  var count=completedStepCount();
  var startButton=q("[data-start-mission]");
  if(startButton){
    startButton.textContent=count>0&&!isComplete()?"Resume Mission":"Start Mission";
  }
  var hero=q("[data-hero]");
  if(!hero||q("[data-mission-resume]")||count===0||isComplete()){return;}
  var next=firstIncompleteStep();
  var box=document.createElement("div");
  box.className="ptiq-mission-resume";
  box.setAttribute("data-mission-resume","");
  box.innerHTML="<strong>Pick up where you left off</strong><span>"+count+" of "+mission.steps.length+" steps complete"+(next?". Next: "+esc(next.label)+".":".")+"</span>";
  hero.appendChild(box);
}
function refreshEntitlement(){
  var nowLocked=day>4&&!hasPlusAccess();
  if(nowLocked===locked){return;}
  locked=nowLocked;
  mission=locked?null:MISSIONS[day];
  window.location.reload();
}
window.addEventListener("pageshow",refreshEntitlement);
window.addEventListener("pretrip:entitlements-updated",refreshEntitlement);


function founderLabel(event){
  var labels={
    student_opened:"Student opened app",
    study_started:"Study session started",
    study_completed:"Study session completed",
    parts_started:"Parts IQ started",
    parts_completed:"Parts IQ completed",
    voice_started:"Voice Coach started",
    voice_completed:"Voice Coach completed",
    mission_started:"Mission started",
    mission_completed:"Mission completed",
    inspection_started:"Inspection started",
    inspection_completed:"Inspection completed",
    practice_test_started:"Practice test started",
    practice_test_completed:"Practice test completed",
    mock_exam_completed:"Mock exam completed",
    readiness_opened:"Readiness IQ opened",
    upgrade_viewed:"Upgrade viewed",
    upgrade_tapped:"Upgrade tapped",
    apple_sheet_opened:"Apple purchase sheet opened",
    subscription_started:"Subscription started",
    restore_completed:"Restore completed",
    purchase_error:"Purchase error",
    microphone_error:"Microphone error",
    voice_recognition_error:"Voice recognition error",
    coach_response_played:"Voice Coach feedback played",
    coach_retry_requested:"Voice Coach retry requested",
    coach_retry_completed:"Voice Coach retry completed",
    coach_advance:"Voice Coach advanced student",
    voice_timeout:"Voice Coach timeout",
    voice_abandon:"Voice Coach abandoned",
    progression_nudge_shown:"Progression recommendation shown",
    progression_nudge_tapped:"Progression recommendation tapped",
    progression_step_advanced:"Student advanced to next training step",
    coach_guidance_spoken:"Voice Coach guidance spoken",
    coach_audio_toggled:"Voice Coach audio changed",
    quiz_results_coached:"Knowledge Check results coached",
    stage_transition_coached:"Voice Coach guided next step"
  };
  return labels[event]||String(event||"").replace(/_/g," ");
}

function founderTrack(eventName,payload){
  var event=String(eventName||"").trim();
  payload=payload||{};
  if(!event){return false;}

  var now=Date.now();
  var record={
    id:String(now)+"_"+Math.random().toString(16).slice(2),
    app:"pretrip_iq",
    event:event,
    eventName:event,
    occurredAt:new Date(now).toISOString(),
    at:now,
    day:day,
    missionTitle:mission?mission.title:"",
    sessionId:founderPageSessionId,
    deviceId:founderDeviceId(),
    userId:founderDeviceId(),
    appVersion:String(window.PRE_TRIP_IQ_MISSION_BUILD||""),
    platform:"ios",
    payload:payload
  };

  try{
    var events=readJSON(FOUNDER_EVENTS_KEY,[]);
    if(!Array.isArray(events)){events=[];}
    events.unshift(record);
    var cutoff=now-(35*24*60*60*1000);
    events=events.filter(function(item){
      return Number(item&&item.at||0)>=cutoff;
    }).slice(0,2500);
    localStorage.setItem(FOUNDER_EVENTS_KEY,JSON.stringify(events));
  }catch(e){}

  founderSend(record);

  /*
    Keep the existing Founder IQ v1 dashboard working immediately.
    This updates its legacy aggregate state on the same Shopify origin.
  */
  try{
    var founder=readJSON(FOUNDER_STATE_KEY,{});
    if(!founder||typeof founder!=="object"||Array.isArray(founder)){founder={};}
    founder[event]=Number(founder[event]||0)+Number(payload.amount||1);

    if(event==="voice_completed"&&isFinite(Number(payload.score))){
      founder.voice_score_total=Number(founder.voice_score_total||0)+Number(payload.score);
      founder.voice_score_count=Number(founder.voice_score_count||0)+1;
    }

    if(!Array.isArray(founder.activity)){founder.activity=[];}
    founder.activity.unshift({
      id:record.id,
      event:event,
      label:founderLabel(event),
      detail:payload.detail?String(payload.detail):"",
      at:now
    });
    founder.activity=founder.activity.slice(0,20);

    if(!Array.isArray(founder.alerts)){founder.alerts=[];}
    if(event==="voice_completed"){
      founder.alerts.unshift({
        id:"alert_"+record.id,
        message:"Voice Coach session completed in Mission "+day+".",
        tone:"good",
        at:now
      });
    }
    if(event==="microphone_error"||event==="voice_recognition_error"){
      founder.alerts.unshift({
        id:"alert_"+record.id,
        message:event==="microphone_error"
          ?"Microphone error recorded in Mission "+day+"."
          :"Voice recognition error recorded in Mission "+day+".",
        tone:"bad",
        at:now
      });
    }
    founder.alerts=founder.alerts.slice(0,12);
    founder.updatedAt=now;
    localStorage.setItem(FOUNDER_STATE_KEY,JSON.stringify(founder));
  }catch(e){}

  try{
    if(window.PreTripFounderIQ&&typeof window.PreTripFounderIQ.track==="function"){
      window.PreTripFounderIQ.track(event,payload);
    }
  }catch(e){}

  try{
    window.dispatchEvent(new CustomEvent("pretrip:founder-event",{
      detail:{event:event,payload:payload,record:record}
    }));
  }catch(e){}

  try{
    if(typeof window.gtag==="function"){
      window.gtag("event",event,{
        app_name:"pretrip_iq",
        mission_day:day,
        mission_title:mission?mission.title:"",
        score:isFinite(Number(payload.score))?Number(payload.score):undefined
      });
    }
  }catch(e){}

  return true;
}

function trackOnce(flag,event,payload){
  if(state[flag]){return false;}
  state[flag]=true;
  writeJSON(missionKey,state);
  return founderTrack(event,payload||{});
}

function scoreVoiceTranscript(transcript,target){
  var spoken=String(transcript||"").toLowerCase().match(/[a-z0-9]+/g)||[];
  var expected=String(target||"").toLowerCase().match(/[a-z0-9]+/g)||[];
  if(!expected.length||!spoken.length){return null;}
  var spokenSet={};
  spoken.forEach(function(word){spokenSet[word]=true;});
  var matched=expected.filter(function(word){return spokenSet[word];}).length;
  return Math.max(0,Math.min(100,Math.round((matched/expected.length)*100)));
}

function readJSON(k,f){try{var v=JSON.parse(localStorage.getItem(k)||"null");return v==null?f:v;}catch(e){return f;}}function writeJSON(k,v){try{localStorage.setItem(k,JSON.stringify(v));}catch(e){}}function q(s){return root.querySelector(s);}function qa(s){return Array.prototype.slice.call(root.querySelectorAll(s));}function esc(s){return String(s==null?"":s).replace(/[&<>\"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c];});}function setText(s,v){var e=q(s);if(e){e.textContent=v;}}function isComplete(){return completedDays.map(Number).indexOf(day)>=0;}function scrollToStage(id){var e=q('[data-stage="'+id+'"]');if(e){e.scrollIntoView({behavior:"smooth",block:"start"});}}
function render(){setText("[data-nav-day]","DAY "+day+" OF 21");var f=q("[data-nav-fill]");if(f){f.style.width=Math.max(4.76,(day/21)*100)+"%";}if(!mission){qa("[data-hero],[data-stages],[data-completion-panel]").forEach(function(e){e.hidden=true;});var p=q("[data-paywall-panel]");if(p&&locked){ptiqBuildLockedPaywall(p);}return;}setText("[data-mission-pill]","DAY "+day+" · "+mission.week);setText("[data-mission-title]",mission.title);setText("[data-mission-summary]",mission.summary);setText("[data-mission-time]",mission.time);setText("[data-mission-focus]",mission.focus);if(isComplete()){mission.steps.forEach(function(s){state[s.id]=true;});writeJSON(missionKey,state);}renderPlan();renderStages();renderQuickNav();renderCoachAudioControl();renderProgress();renderResumeCue();}
function renderPlan(){q("[data-plan-list]").innerHTML=mission.steps.map(function(s,i){return '<li data-plan-step="'+esc(s.id)+'"><b>'+String(i+1).padStart(2,"0")+'</b><span><strong>'+esc(s.label)+'</strong><small>'+esc(s.desc)+'</small></span><i>○</i></li>';}).join("");}
function stageHTML(s,i){var inner='<span class="ptiq-mission-kicker">'+esc(s.label.toUpperCase())+'</span><h2>'+esc(s.heading)+'</h2>'+(s.body?'<p>'+esc(s.body)+'</p>':'');if(s.type==="brief"){inner+='<div class="ptiq-mission-note"><strong>TODAY\'S GOAL</strong><span>'+esc(s.note)+'</span></div>';}if(s.type==="cards"){inner+='<div class="ptiq-mission-learn-grid">'+s.cards.map(function(c,j){return '<article><b>'+String(j+1).padStart(2,"0")+'</b><strong>'+esc(c[0])+'</strong><span>'+esc(c[1])+'</span></article>';}).join("")+'</div>';}if(s.type==="components"){inner+='<div class="ptiq-mission-components">'+s.components.map(function(c,j){return '<article class="ptiq-mission-component"><small>COMPONENT '+String(j+1).padStart(2,"0")+'</small><strong>'+esc(c[0])+'</strong><span>'+esc(c[1])+'</span>'+(c[2]?'<div class="ptiq-mission-component__detail"><b>PURPOSE</b><em>'+esc(c[2])+'</em><b>COMMON DEFECTS</b><em>'+esc(c[3]||"")+'</em><b>CDL COACH TIP</b><em>'+esc(c[4]||"")+'</em></div>':'')+'</article>';}).join("")+'</div><div class="ptiq-mission-camera-preview"><div><span>VISUAL TRAINING</span><h3>Use Parts IQ and the real truck.</h3><p>Reference images and future camera verification will reinforce these components inside the mission flow.</p></div><a class="ptiq-mission-btn ptiq-mission-btn--secondary" href="'+URLS.parts+'">Open Parts IQ</a></div>';}if(s.type==="partsChallenge"){inner+='<div class="ptiq-parts-iq" data-parts-iq><div class="ptiq-parts-iq__top"><div><small>INTERACTIVE PARTS IQ</small><strong data-parts-name>Challenge 1 of '+s.challenges.length+'</strong></div><span class="ptiq-parts-iq__score" data-parts-score>0 correct</span></div><div class="ptiq-parts-iq__prompt"><h3 data-parts-clue></h3><p>First identify the component. Then choose every inspection point that applies.</p></div><div class="ptiq-parts-iq__options" data-parts-identify></div><div class="ptiq-parts-iq__options" data-parts-checks hidden></div><div class="ptiq-parts-iq__feedback" data-parts-feedback aria-live="polite">Choose the component that matches the clue.</div><div class="ptiq-parts-iq__progress"><span data-parts-progress></span></div><div class="ptiq-parts-iq__actions"><button class="ptiq-mission-btn ptiq-mission-btn--secondary" type="button" data-parts-retry hidden>Try Again</button><button class="ptiq-mission-btn ptiq-mission-btn--primary" type="button" data-parts-submit>Check Component</button></div></div>';return '<section class="ptiq-mission-stage" data-stage="'+esc(s.id)+'"><div class="ptiq-mission-stage__number">'+String(i+1).padStart(2,"0")+'</div><div class="ptiq-mission-stage__content">'+inner+'</div></section>';}if(s.type==="voice"){inner+='<div class="ptiq-voice-journey"><small>HEAR IT · SEE IT · SAY IT · COACH</small><blockquote data-voice-target>'+esc(s.prompt)+'</blockquote></div><div class="ptiq-mission-voice"><button class="ptiq-mission-mic" type="button" data-mic-button aria-pressed="false"><span>🎙</span><strong data-mic-title>Your Turn</strong><small data-mic-subtitle>Hear the example first, then say it in your own words</small></button><div class="ptiq-mission-transcript"><small>VOICE COACH · <b data-voice-state>READY</b></small><p data-voice-status>Ready when you are.</p><div data-transcript>What you say will appear here.</div><div class="ptiq-mission-voice-feedback" data-voice-feedback>After you answer, Coach will reinforce what you got right and tell you exactly what to add.</div></div></div><div class="ptiq-mission-voice-actions"><button class="ptiq-mission-btn ptiq-mission-btn--secondary" type="button" data-hear-coach>Hear It First</button><button class="ptiq-mission-btn ptiq-mission-btn--secondary" type="button" data-skip-voice>Show Me / Continue</button><button class="ptiq-mission-btn ptiq-mission-btn--primary" type="button" data-complete-step="'+esc(s.id)+'" disabled>Complete Voice Drill</button></div>';return '<section class="ptiq-mission-stage" data-stage="'+esc(s.id)+'"><div class="ptiq-mission-stage__number">'+String(i+1).padStart(2,"0")+'</div><div class="ptiq-mission-stage__content">'+inner+'</div></section>';}if(s.type==="quiz"){inner+='<form class="ptiq-mission-quiz" data-quiz-form>'+s.questions.map(function(question,qi){return '<fieldset><legend>'+(qi+1)+'. '+esc(question[0])+'</legend>'+question[1].map(function(a,ai){return '<label><input type="radio" name="q'+qi+'" value="'+ai+'"> '+esc(a)+'</label>';}).join("")+'<div class="ptiq-mission-correction" data-correction="'+qi+'" hidden></div></fieldset>';}).join("")+'<div class="ptiq-mission-quiz__result" data-quiz-result aria-live="polite">Answer all five questions when you are ready.</div><button class="ptiq-mission-btn ptiq-mission-btn--primary" type="submit">Check My Answers</button></form>';return '<section class="ptiq-mission-stage" data-stage="'+esc(s.id)+'"><div class="ptiq-mission-stage__number">'+String(i+1).padStart(2,"0")+'</div><div class="ptiq-mission-stage__content">'+inner+'</div></section>';}var following=mission.steps[i+1]||null;inner+='<button class="ptiq-mission-btn ptiq-mission-btn--primary" type="button" data-complete-step="'+esc(s.id)+'">'+esc(following?progressionStageLabel(following):"Complete This Step")+' <span>→</span></button>';return '<section class="ptiq-mission-stage" data-stage="'+esc(s.id)+'"><div class="ptiq-mission-stage__number">'+String(i+1).padStart(2,"0")+'</div><div class="ptiq-mission-stage__content">'+inner+'</div></section>';}
function renderStages(){var launch="";if(day===2){launch='<div class="ptiq-mission-launch"><span class="ptiq-mission-kicker">MISSION LAUNCH</span><h2>Master the engine compartment.</h2><p>By the end of this mission, you should be able to identify the major components, describe what to inspect, and explain the safety purpose behind each check.</p><div class="ptiq-mission-launch__grid"><article><small>TIME</small><strong>'+esc(mission.time)+'</strong></article><article><small>REWARD PREVIEW</small><strong>'+esc(mission.rewardPreview||"")+'</strong></article><article><small>COACH TIP</small><strong>'+esc(mission.launchTip||mission.coach)+'</strong></article></div></div>';}q("[data-stages]").innerHTML=launch+'<div class="ptiq-mission-coach"><small>AI COACH</small><p>'+esc(mission.coach)+'</p></div>'+mission.steps.map(stageHTML).join("");bindStageEvents();}
function bindPartsChallenge(){var step=mission&&mission.steps.filter(function(x){return x.type==="partsChallenge";})[0];var wrap=q("[data-parts-iq]");if(!step||!wrap){return;}trackOnce("analyticsPartsStarted","parts_started",{day:day,missionTitle:mission.title});var index=0,score=0,phase="identify",selectedComponent=-1,selectedChecks=[];var nameEl=q("[data-parts-name]"),scoreEl=q("[data-parts-score]"),clueEl=q("[data-parts-clue]"),identifyEl=q("[data-parts-identify]"),checksEl=q("[data-parts-checks]"),feedback=q("[data-parts-feedback]"),progress=q("[data-parts-progress]"),submit=q("[data-parts-submit]"),retry=q("[data-parts-retry]");function setFeedback(text,kind){feedback.textContent=text;feedback.className="ptiq-parts-iq__feedback"+(kind?" "+kind:"");}function renderChallenge(){var c=step.challenges[index];phase="identify";selectedComponent=-1;selectedChecks=[];nameEl.textContent="Challenge "+(index+1)+" of "+step.challenges.length;scoreEl.textContent=score+" correct";clueEl.textContent=c.clue;progress.style.width=Math.round(index/step.challenges.length*100)+"%";checksEl.hidden=true;checksEl.innerHTML="";identifyEl.hidden=false;identifyEl.innerHTML=c.choices.map(function(choice,i){return '<button class="ptiq-parts-iq__option" type="button" data-identify-choice="'+i+'">'+esc(choice)+'</button>';}).join("");submit.textContent="Check Component";submit.disabled=false;retry.hidden=true;setFeedback("Choose the component that matches the clue.","");qa("[data-identify-choice]").forEach(function(btn){btn.addEventListener("click",function(){selectedComponent=Number(btn.getAttribute("data-identify-choice"));qa("[data-identify-choice]").forEach(function(x){x.classList.remove("is-selected");});btn.classList.add("is-selected");});});}function renderChecks(){var c=step.challenges[index];phase="checks";identifyEl.hidden=true;checksEl.hidden=false;checksEl.innerHTML=c.checks.map(function(check,i){return '<button class="ptiq-parts-iq__option" type="button" data-check-choice="'+i+'">'+esc(check)+'</button>';}).join("");submit.textContent="Check Inspection Points";setFeedback("Correct component. Select every inspection point that applies.","is-success");qa("[data-check-choice]").forEach(function(btn){btn.addEventListener("click",function(){var n=Number(btn.getAttribute("data-check-choice"));var pos=selectedChecks.indexOf(n);if(pos>=0){selectedChecks.splice(pos,1);btn.classList.remove("is-selected");}else{selectedChecks.push(n);btn.classList.add("is-selected");}});});}function sameSet(a,b){return a.slice().sort().join(",")===b.slice().sort().join(",");}submit.addEventListener("click",function(){var c=step.challenges[index];if(phase==="identify"){if(selectedComponent<0){setFeedback("Choose a component before checking your answer.","is-error");return;}if(selectedComponent!==c.correct){qa("[data-identify-choice]").forEach(function(btn){var n=Number(btn.getAttribute("data-identify-choice"));btn.classList.toggle("is-wrong",n===selectedComponent);btn.classList.toggle("is-correct",n===c.correct);});setFeedback("Not quite. "+c.coach+" Try again — you've got this.","is-error");coachSpeakGlobal("Not quite. "+c.coach+" Try again. You've got this.",{kind:"parts_correction"});retry.hidden=false;submit.disabled=true;return;}renderChecks();return;}if(!selectedChecks.length){setFeedback("Select the inspection points that apply.","is-error");return;}if(!sameSet(selectedChecks,c.required)){qa("[data-check-choice]").forEach(function(btn){var n=Number(btn.getAttribute("data-check-choice"));btn.classList.toggle("is-correct",c.required.indexOf(n)>=0);btn.classList.toggle("is-wrong",selectedChecks.indexOf(n)>=0&&c.required.indexOf(n)<0);});setFeedback("Review this one: "+c.coach+" Try again — you've got this.","is-error");coachSpeakGlobal("Review this one. "+c.coach+" Try again. You've got this.",{kind:"parts_correction"});retry.hidden=false;submit.disabled=true;return;}score++;scoreEl.textContent=score+" correct";setFeedback("Excellent. You identified the part and selected the complete inspection checks.","is-success");submit.disabled=true;setTimeout(function(){index++;if(index>=step.challenges.length){progress.style.width="100%";state.parts=true;state.partsScore=score;writeJSON(missionKey,state);trackOnce("analyticsPartsCompleted","parts_completed",{day:day,missionTitle:mission.title,score:score,total:step.challenges.length});renderProgress();wrap.innerHTML='<div class="ptiq-mission-reward"><strong>Parts IQ complete</strong><span>'+score+' of '+step.challenges.length+' component challenges mastered. Parts Recognition +6.</span></div><button class="ptiq-mission-btn ptiq-mission-btn--primary" type="button" data-parts-continue>Continue to Voice Coach</button>';coachSpeakGlobal("Parts IQ complete. You mastered "+score+" of "+step.challenges.length+". Next, Voice Coach. Let's say it out loud.",{kind:"parts_complete"});var next=wrap.querySelector("[data-parts-continue]");if(next){next.addEventListener("click",function(){scrollToStage("voice");});}return;}renderChallenge();},650);});retry.addEventListener("click",renderChallenge);renderChallenge();}
function bindStageEvents(){
  qa("[data-complete-step]").forEach(function(b){
    b.addEventListener("click",function(){
      completeStep(b.getAttribute("data-complete-step"));
    });
  });

  bindPartsChallenge();

  var mic=q("[data-mic-button]");
  var voiceButton=q('[data-complete-step="voice"]');
  var hearCoach=q("[data-hear-coach]");
  var voiceStep=(mission.steps.filter(function(step){return step.id==="voice";})[0]||{});
  var voiceTarget=String(voiceStep.prompt||"");
  var maxRequiredRetry=1;

  if(voiceStep&&voiceStep.id){
    founderTrack("voice_screen_viewed",{
      day:day,
      missionTitle:mission.title,
      source:"mission_voice_stage"
    });
  }

  function setVoiceState(stateName,statusText){
    voiceCoachState=String(stateName||"ready").toLowerCase();
    setText("[data-voice-state]",voiceCoachState.toUpperCase());
    if(statusText){setText("[data-voice-status]",statusText);}

    if(mic){
      mic.classList.toggle("is-listening",voiceCoachState==="listening");
      mic.setAttribute("aria-pressed",voiceCoachState==="listening"?"true":"false");

      var title=mic.querySelector("[data-mic-title]");
      var subtitle=mic.querySelector("[data-mic-subtitle]");

      if(title){
        title.textContent=
          voiceCoachState==="listening"?"Listening…":
          voiceCoachState==="checking"?"Checking…":
          voiceCoachState==="coaching"?"Coach is speaking…":
          voiceCoachState==="complete"?"Ready to Continue":
          !voiceAttempt.demoPlayed?"Hear Coach First":
          voiceAttempt.retryCount>0?"Try Again":"Your Turn";
      }

      if(subtitle){
        subtitle.textContent=
          voiceCoachState==="listening"?"Say the inspection clearly":
          voiceCoachState==="checking"?"Comparing your answer with the required safety points":
          voiceCoachState==="coaching"?"The microphone is paused while Coach talks":
          voiceCoachState==="complete"?"Inspection accepted — keep moving":
          !voiceAttempt.demoPlayed?"Listen once before you practice":
          voiceAttempt.retryCount>0?"Tap for one focused retry":"Say the important safety checks in your own words";
      }
    }
  }

  function enableVoiceCompletion(enabled){
    if(voiceButton){voiceButton.disabled=!enabled;}
  }

  function stopVoiceRecognition(){
    if(voiceCoachRestartTimer){
      clearTimeout(voiceCoachRestartTimer);
      voiceCoachRestartTimer=null;
    }
    if(voiceRecognitionSilenceTimer){clearTimeout(voiceRecognitionSilenceTimer);voiceRecognitionSilenceTimer=null;}
    if(voiceRecognitionHardStopTimer){clearTimeout(voiceRecognitionHardStopTimer);voiceRecognitionHardStopTimer=null;}
    if(recognition){
      try{
        recognition.onresult=null;
        recognition.onerror=null;
        recognition.onend=null;
        recognition.stop();
      }catch(e){}
      recognition=null;
    }
    if(mic){
      mic.classList.remove("is-listening");
      mic.setAttribute("aria-pressed","false");
    }
  }

  function coachCanSpeak(){
    return !!(window.speechSynthesis&&window.SpeechSynthesisUtterance);
  }

  function speakCoach(textToSpeak,options){
    options=options||{};
    var line=String(textToSpeak||"").replace(/\s+/g," ").trim();
    if(!line){
      if(typeof options.onDone==="function"){options.onDone();}
      return false;
    }

    if(!coachAudioEnabled&&options.forceAudio!==true){
      voiceAttempt.lastCoachText=line;
      if(typeof options.onDone==="function"){options.onDone();}
      return false;
    }

    stopVoiceRecognition();
    voiceCoachSpeaking=true;
    voiceAttempt.lastCoachText=line;
    setVoiceState("coaching","Coach is responding…");

    founderTrack("coach_response_played",{
      day:day,
      missionTitle:mission.title,
      attempt:voiceAttempt.attemptCount,
      retryCount:voiceAttempt.retryCount,
      accepted:options.accepted===true,
      missed:Array.isArray(voiceAttempt.lastMissed)?voiceAttempt.lastMissed.slice(0,6):[],
      detail:line.slice(0,220)
    });

    if(!coachCanSpeak()){
      voiceCoachSpeaking=false;
      setVoiceState(options.accepted===true?"complete":"ready",options.accepted===true?"Answer accepted.":"Coach feedback is ready. Try it again.");
      if(typeof options.onDone==="function"){options.onDone();}
      return false;
    }

    try{window.speechSynthesis.cancel();}catch(e){}
    if(voiceCoachSpeechTimer){clearTimeout(voiceCoachSpeechTimer);voiceCoachSpeechTimer=null;}

    try{
      var utterance=coachCreateUtterance(line,options);
      if(!utterance){voiceCoachSpeaking=false;if(typeof options.onDone==="function"){options.onDone();}return false;}

      var finish=function(){
        if(!voiceCoachSpeaking){return;}
        if(voiceCoachSpeechTimer){clearTimeout(voiceCoachSpeechTimer);voiceCoachSpeechTimer=null;}
        voiceCoachSpeaking=false;
        if(typeof options.onDone==="function"){options.onDone();}
      };

      utterance.onend=finish;
      utterance.onerror=finish;
      window.speechSynthesis.speak(utterance);
      voiceCoachSpeechTimer=setTimeout(finish,Math.max(6500,Math.min(22000,line.length*72)));
      return true;
    }catch(e){
      voiceCoachSpeaking=false;
      if(typeof options.onDone==="function"){options.onDone();}
      return false;
    }
  }

  function sentencePieces(target){
    return String(target||"")
      .split(/(?<=[.!?])\s+/)
      .map(function(piece){return piece.trim();})
      .filter(Boolean);
  }

  function conciseIdealForMissed(missed){
    var checks=mission&&Array.isArray(mission.voiceChecks)?mission.voiceChecks:[];
    var wantedTerms=[];
    checks.forEach(function(check){
      if(missed.indexOf(check.label)<0){return;}
      (Array.isArray(check.terms)?check.terms:[]).forEach(function(term){
        wantedTerms.push(String(term||"").toLowerCase());
      });
    });

    var pieces=sentencePieces(voiceTarget);
    var chosen=pieces.filter(function(sentence){
      var low=sentence.toLowerCase();
      return wantedTerms.some(function(term){return term&&low.indexOf(term)>=0;});
    });

    var result=(chosen.length?chosen:[voiceTarget]).join(" ").replace(/\s+/g," ").trim();
    if(result.length>220){result=result.slice(0,217).replace(/\s+\S*$/,"")+"…";}
    return result;
  }

  function evaluateVoiceTranscript(transcript){
    var cleaned=String(transcript||"").replace(/\s+/g," ").trim();
    var lower=cleaned.toLowerCase();
    var checks=mission&&Array.isArray(mission.voiceChecks)?mission.voiceChecks:[];
    var covered=[];
    var missed=[];

    checks.forEach(function(check){
      var terms=Array.isArray(check.terms)?check.terms:[];
      var found=terms.some(function(term){
        return lower.indexOf(String(term||"").toLowerCase())!==-1;
      });
      if(found){covered.push(check.label);}
      else{missed.push(check.label);}
    });

    var score=scoreVoiceTranscript(cleaned,voiceTarget);
    var wordCount=cleaned?cleaned.split(/\s+/).length:0;
    var coveredRatio=checks.length?covered.length/checks.length:0;
    var accepted=checks.length
      ? (coveredRatio>=0.6||Number(score||0)>=45)&&wordCount>=5
      : Number(score||0)>=45&&wordCount>=5;

    return {
      transcript:cleaned,
      score:score,
      wordCount:wordCount,
      checks:checks,
      covered:covered,
      missed:missed,
      accepted:accepted
    };
  }

  function playCoachExample(source){
    voiceAttempt.demoPlayed=true;
    founderTrack("voice_example_played",{
      day:day,
      missionTitle:mission.title,
      source:String(source||"hear_first")
    });
    setText("[data-voice-feedback]",voiceTarget);
    speakCoach("Listen first. "+voiceTarget,{
      accepted:false,
      forceAudio:true,
      onDone:function(){
        setVoiceState("ready","Your turn. Say the important safety checks in your own words.");
        enableVoiceCompletion(true);
      }
    });
  }

  function nextMissionStepAfterVoice(){
    var steps=mission&&Array.isArray(mission.steps)?mission.steps:[];
    var voiceIndex=steps.map(function(step){return step.id;}).indexOf("voice");
    if(voiceIndex<0||voiceIndex>=steps.length-1){return null;}
    return steps[voiceIndex+1]||null;
  }

  function nextFlowLabel(){
    var next=nextMissionStepAfterVoice();
    if(!next){return "the next section";}
    return String(next.label||next.heading||"the next section").replace(/\s+/g," ").trim();
  }

  function compactCovered(covered){
    covered=Array.isArray(covered)?covered.filter(Boolean):[];
    if(!covered.length){return "";}
    if(covered.length===1){return covered[0];}
    if(covered.length===2){return covered[0]+" and "+covered[1];}
    return covered.slice(0,2).join(", ")+" and the rest";
  }

  function acceptedFlowLine(result){
    var covered=result.covered||[];
    var nextLabel=nextFlowLabel();
    var corrected=voiceAttempt.attemptCount>1||voiceAttempt.retryCount>0;
    var lead=corrected?"That's it. ":"Yep, that's right. ";
    var detail=compactCovered(covered);

    if(detail){
      return lead+"You covered "+detail+". Keep that wording. Next, "+nextLabel+".";
    }

    return lead+"That inspection is complete. Keep the same sequence. Next, "+nextLabel+".";
  }

  function retryFlowLine(result){
    var covered=result.covered||[];
    var missed=result.missed||[];
    var intro=covered.length
      ?"Good start. You already have "+compactCovered(covered)+". "
      :"Good start. ";

    var ideal=conciseIdealForMissed(missed);
    var gap=missed.length?"One thing to add is "+missed.slice(0,3).join(", ")+". ":"";
    return intro+gap+"Say it like this: "+ideal+" Give that one another try.";
  }

  function coachingLine(result){
    var missed=result.missed||[];

    if(result.accepted){
      return acceptedFlowLine(result);
    }

    if(missed.length){
      return retryFlowLine(result);
    }

    return "I need a little more detail. One more try: "+conciseIdealForMissed([]);
  }

  function scheduleRecognitionRecovery(reason){
    if(voiceCoachSpeaking){return false;}
    voiceAttempt.recoveryCount+=1;
    setVoiceState("ready","The microphone paused. Try again, hear the example, or continue.");
    setText("[data-voice-feedback]","No problem. You are not stuck. Choose Try Again, Hear It First, or Show Me / Continue.");
    enableVoiceCompletion(true);
    founderTrack("voice_recognition_recovered",{
      day:day,
      missionTitle:mission.title,
      reason:String(reason||"unknown"),
      recoveryCount:voiceAttempt.recoveryCount
    });
    return false;
  }

  function finishEvaluation(transcript){
    setVoiceState("checking","Checking your inspection language…");

    var result=evaluateVoiceTranscript(transcript);
    voiceAttempt.responseReceived=true;
    founderTrack("voice_response_received",{
      day:day,
      missionTitle:mission.title,
      attempt:voiceAttempt.attemptCount,
      wordCount:result.wordCount
    });
    voiceAttempt.transcript=result.transcript;
    voiceAttempt.score=result.score;
    voiceAttempt.lastMissed=result.missed.slice();
    setText("[data-transcript]",result.transcript||"I did not catch enough speech to score that attempt.");

    if(result.wordCount<4){
      founderTrack("voice_timeout",{
        day:day,
        missionTitle:mission.title,
        attempt:voiceAttempt.attemptCount,
        detail:"Too little speech captured to evaluate"
      });
      setText("[data-voice-feedback]","I did not catch enough of that answer. Try again and speak the inspection at a normal pace.");
      setVoiceState("ready","I did not catch enough. Try again.");
      enableVoiceCompletion(true);
      scheduleRecognitionRecovery("short_transcript");
      return;
    }

    voiceAttempt.recoveryCount=0;

    var line=coachingLine(result);
    setText("[data-voice-feedback]",line);

    if(result.accepted){
      voiceAttempt.accepted=true;
      if(voiceAttempt.attemptCount>1){
        founderTrack("coach_retry_completed",{
          day:day,
          missionTitle:mission.title,
          attempt:voiceAttempt.attemptCount,
          score:result.score,
          detail:"Student completed the Voice Coach retry"
        });
      }

      speakCoach(line,{
        accepted:true,
        onDone:function(){
          setVoiceState("complete","Nice work. Continue when you are ready.");
          enableVoiceCompletion(true);
        }
      });
      founderTrack("voice_feedback_played",{day:day,missionTitle:mission.title,accepted:true,score:result.score});
      return;
    }

    if(voiceAttempt.retryCount<maxRequiredRetry){
      voiceAttempt.retryCount+=1;
      founderTrack("coach_retry_requested",{
        day:day,
        missionTitle:mission.title,
        attempt:voiceAttempt.attemptCount,
        score:result.score,
        missed:result.missed.slice(0,6),
        detail:"Voice Coach requested one focused retry"
      });

      enableVoiceCompletion(false);
      speakCoach(line,{
        accepted:false,
        onDone:function(){
          setVoiceState("ready","Your turn. Try that one correction, or continue.");
          enableVoiceCompletion(true);
        }
      });
      founderTrack("voice_feedback_played",{day:day,missionTitle:mission.title,accepted:false,score:result.score});
      return;
    }

    var finalLine="You're close. Keep this wording in mind: "+conciseIdealForMissed(result.missed||[])+" Give it another try when you're ready.";
    setText("[data-voice-feedback]",finalLine);
    enableVoiceCompletion(true);
    speakCoach(finalLine,{
      accepted:false,
      onDone:function(){
        setVoiceState("ready","Retry if you want, or continue and keep the correction in mind.");
      }
    });
  }

  function startVoiceRecognition(isAutoRetry){
    if(voiceCoachSpeaking||voiceCoachState==="checking"){return;}

    var SR=window.SpeechRecognition||window.webkitSpeechRecognition;
    if(!SR){
      founderTrack("microphone_error",{
        day:day,
        missionTitle:mission.title,
        detail:"Speech recognition unavailable"
      });
      setVoiceState("ready","Speech recognition is unavailable here.");
      setText("[data-voice-feedback]","You may hear the Coach example or complete the drill without the microphone.");
      enableVoiceCompletion(true);
      return;
    }

    stopVoiceRecognition();
    voiceRecognitionGeneration+=1;
    var generation=voiceRecognitionGeneration;
    var finalTranscript="";
    var liveTranscript="";
    var recognitionHandled=false;

    try{
      recognition=new SR();
      recognition.lang="en-US";
      recognition.interimResults=true;
      recognition.continuous=true;

      recognition.onstart=function(){
        if(generation!==voiceRecognitionGeneration){return;}
        voiceAttempt.started=true;
        if(!voiceAttempt.startedAt){voiceAttempt.startedAt=Date.now();}
        voiceAttempt.attemptCount+=1;

        trackOnce("analyticsVoiceStarted","voice_started",{
          day:day,
          missionTitle:mission.title,
          detail:"Microphone started"
        });
        founderTrack("voice_recognition_started",{
          day:day,
          missionTitle:mission.title,
          attempt:voiceAttempt.attemptCount
        });

        setVoiceState("listening",isAutoRetry?"Listening for your retry…":"Listening… say the inspection.");
        setText("[data-transcript]","Listening…");
        if(voiceRecognitionHardStopTimer){clearTimeout(voiceRecognitionHardStopTimer);}
        voiceRecognitionHardStopTimer=setTimeout(function(){
          if(generation!==voiceRecognitionGeneration||!recognition){return;}
          try{recognition.stop();}catch(e){}
        },38000);
      };

      recognition.onresult=function(e){
        if(generation!==voiceRecognitionGeneration){return;}
        liveTranscript="";

        for(var i=Number(e.resultIndex||0);i<e.results.length;i++){
          var chunk=e.results[i]&&e.results[i][0]?String(e.results[i][0].transcript||""):"";
          if(e.results[i].isFinal){finalTranscript+=chunk+" ";}
          else{liveTranscript+=chunk+" ";}
        }

        var display=(finalTranscript+" "+liveTranscript).replace(/\s+/g," ").trim();
        voiceAttempt.transcript=display;
        setText("[data-transcript]",display||"Listening…");
        if(voiceRecognitionSilenceTimer){clearTimeout(voiceRecognitionSilenceTimer);}
        voiceRecognitionSilenceTimer=setTimeout(function(){
          if(generation!==voiceRecognitionGeneration||!recognition){return;}
          try{recognition.stop();}catch(e){}
        },2600);
      };

      recognition.onerror=function(e){
        if(generation!==voiceRecognitionGeneration){return;}
        var err=e&&e.error?String(e.error):"unknown";
        voiceAttempt.recognitionErrors+=1;

        founderTrack("voice_recognition_error",{
          day:day,
          missionTitle:mission.title,
          error:err,
          attempt:voiceAttempt.attemptCount,
          detail:"Recognition could not complete"
        });

        if(err==="no-speech"||err==="audio-capture"||err==="network"){
          founderTrack("voice_timeout",{
            day:day,
            missionTitle:mission.title,
            error:err,
            attempt:voiceAttempt.attemptCount,
            detail:"Voice attempt ended without usable speech"
          });
        }

        var captured=(finalTranscript+" "+liveTranscript).replace(/\s+/g," ").trim()||String(voiceAttempt.transcript||"").trim();
        if(captured.split(/\s+/).filter(Boolean).length>=4){
          recognitionHandled=true;
          finishEvaluation(captured);
          return;
        }
        if(err==="not-allowed"||err==="service-not-allowed"){
          setVoiceState("ready","Microphone access is off.");
          setText("[data-voice-feedback]","Allow microphone access in Safari settings, then tap Start Voice Coach. You can still complete this drill without the microphone.");
          enableVoiceCompletion(true);
          return;
        }
        if(err!=="aborted"&&scheduleRecognitionRecovery(err)){return;}
        setVoiceState("ready","I couldn't catch that one. Tap to retry.");
        setText("[data-voice-feedback]","I did not get enough audio to check that answer. Try again at a normal speaking pace.");
        enableVoiceCompletion(true);
      };

      recognition.onend=function(){
        if(generation!==voiceRecognitionGeneration){return;}
        if(voiceRecognitionSilenceTimer){clearTimeout(voiceRecognitionSilenceTimer);voiceRecognitionSilenceTimer=null;}
        if(voiceRecognitionHardStopTimer){clearTimeout(voiceRecognitionHardStopTimer);voiceRecognitionHardStopTimer=null;}
        recognition=null;
        if(recognitionHandled){return;}
        if(voiceCoachSpeaking){return;}

        var transcript=(finalTranscript+" "+liveTranscript).replace(/\s+/g," ").trim()||String(voiceAttempt.transcript||"").trim();
        if(transcript){
          finishEvaluation(transcript);
        }else if(voiceCoachState==="listening"){
          if(!scheduleRecognitionRecovery("ended_without_transcript")){
            setVoiceState("ready","I didn't hear enough. Tap to retry.");
            enableVoiceCompletion(true);
          }
        }
      };

      recognition.start();
    }catch(e){
      recognition=null;
      founderTrack("microphone_error",{
        day:day,
        missionTitle:mission.title,
        detail:e&&e.message?String(e.message):"Microphone could not start"
      });
      setVoiceState("ready","The microphone could not start.");
      setText("[data-voice-feedback]","You may retry, hear the Coach example, or complete the drill without the microphone.");
      enableVoiceCompletion(true);
    }
  }

  if(mic){
    mic.addEventListener("click",function(){
      if(voiceCoachState==="listening"){
        try{if(recognition){recognition.stop();}}catch(e){}
        return;
      }
      if(!voiceAttempt.demoPlayed){
        playCoachExample("your_turn_guard");
        return;
      }
      founderTrack("voice_your_turn_tapped",{
        day:day,
        missionTitle:mission.title,
        attempt:voiceAttempt.attemptCount+1
      });
      startVoiceRecognition(false);
    });
  }

  if(hearCoach){
    hearCoach.addEventListener("click",function(){
      playCoachExample("hear_again_button");
    });
  }

  var skip=q("[data-skip-voice]");
  if(skip){
    skip.addEventListener("click",function(){
      stopVoiceRecognition();
      if(voiceAttempt.started&&!voiceAttempt.accepted){
        founderTrack("voice_abandon",{
          day:day,
          missionTitle:mission.title,
          attemptCount:voiceAttempt.attemptCount,
          retryCount:voiceAttempt.retryCount,
          detail:"Student completed the voice step without an accepted coached response"
        });
      }
      completeStep("voice",{skipped:true});
    });
  }

  var quiz=q("[data-quiz-form]");
  if(quiz){
    quiz.addEventListener("submit",gradeQuiz);
  }

  enableVoiceCompletion(true);
  setVoiceState("ready","Start by hearing the Coach example. Then say the important checks in your own words.");
}

function completeStep(id,options){
  options=options||{};
  var wasComplete=state[id]===true;
  state[id]=true;
  writeJSON(missionKey,state);

  if(id==="voice"&&!wasComplete){
    var score=isFinite(Number(voiceAttempt.score))?Number(voiceAttempt.score):null;
    if(options.skipped!==true){
      founderTrack("coach_advance",{
        day:day,
        missionTitle:mission.title,
        score:score,
        accepted:voiceAttempt.accepted===true,
        attemptCount:Number(voiceAttempt.attemptCount||0),
        retryCount:Number(voiceAttempt.retryCount||0),
        detail:"Student advanced from the coached voice step"
      });
    }
    trackOnce("analyticsVoiceCompleted","voice_completed",{
      day:day,
      missionTitle:mission.title,
      score:score,
      skipped:options.skipped===true,
      usedMicrophone:voiceAttempt.started===true,
      transcriptWordCount:String(voiceAttempt.transcript||"").trim()
        ?String(voiceAttempt.transcript).trim().split(/\s+/).length
        :0,
      durationSeconds:voiceAttempt.startedAt>0
        ?Math.max(1,Math.round((Date.now()-voiceAttempt.startedAt)/1000))
        :0,
      detail:options.skipped===true
        ?"Voice drill completed without microphone"
        :"Voice drill completed"
    });
    founderTrack("voice_item_completed",{
      day:day,
      missionTitle:mission.title,
      accepted:voiceAttempt.accepted===true,
      skipped:options.skipped===true,
      attemptCount:Number(voiceAttempt.attemptCount||0)
    });
    var completedVoiceItems=readJSON(VOICE_ITEMS_KEY,[]);
    if(!Array.isArray(completedVoiceItems)){completedVoiceItems=[];}
    if(completedVoiceItems.map(Number).indexOf(day)<0){completedVoiceItems.push(day);}
    completedVoiceItems=completedVoiceItems.map(Number).filter(function(n){return n>=1&&n<=21;}).slice(-21);
    writeJSON(VOICE_ITEMS_KEY,completedVoiceItems);
    if(completedVoiceItems.length>=3){
      window.setTimeout(showInspectionHandoff,180);
      return;
    }
  }

  renderProgress();
  var idx=mission.steps.map(function(s){return s.id;}).indexOf(id);
  if(idx>=0&&idx<mission.steps.length-1){
    var nextStep=mission.steps[idx+1];
    if(!wasComplete){
      founderTrack("progression_step_advanced",{
        day:day,
        missionTitle:mission.title,
        fromStep:id,
        toStep:nextStep.id,
        toType:nextStep.type||"",
        version:PTIQ_PROGRESS_VERSION
      });

      /* Voice Coach owns important handoffs, but does not chatter on every tap. */
      if(id!=="voice"){
        var transitionLine=coachStageTransitionLine(id,nextStep);
        if(transitionLine){
          founderTrack("stage_transition_coached",{
            day:day,
            missionTitle:mission.title,
            fromStep:id,
            toStep:nextStep.id,
            detail:transitionLine
          });
          coachSpeakGlobal(transitionLine,{kind:"stage_transition"});
        }
      }else if(options.skipped===true){
        coachSpeakGlobal("No problem. Next, "+String(nextStep.label||"the next section")+".",{kind:"voice_skip_transition"});
      }
    }
    scrollToStage(nextStep.id);
  }
}

function showInspectionHandoff(){
  var stage=q('[data-stage="voice"]');
  if(!stage){return;}
  var content=stage.querySelector(".ptiq-mission-stage__content")||stage;
  var existing=content.querySelector("[data-inspection-handoff]");
  if(existing){existing.scrollIntoView({behavior:"smooth",block:"center"});return;}
  var panel=document.createElement("div");
  panel.className="ptiq-mission-reward";
  panel.setAttribute("data-inspection-handoff","");
  panel.innerHTML='<strong>Nice work. Now let\'s use that on a real inspection.</strong><span>You have completed three coached voice items. Put the language into action while it is fresh.</span><a class="ptiq-mission-btn ptiq-mission-btn--primary" data-start-first-inspection href="'+URLS.inspection+'?ptiq_source=voice_handoff">START MY FIRST INSPECTION <span>→</span></a><button class="ptiq-mission-btn ptiq-mission-btn--secondary" type="button" data-continue-mission>Continue This Mission</button>';
  content.appendChild(panel);
  founderTrack("inspection_cta_shown",{day:day,missionTitle:mission.title,source:"voice_three_item_handoff"});
  coachSpeakGlobal("Nice work. Now let's use that on a real inspection.",{kind:"voice_to_inspection_handoff"});
  var startInspection=panel.querySelector("[data-start-first-inspection]");
  if(startInspection){
    startInspection.addEventListener("click",function(){
      founderTrack("inspection_cta_tapped",{day:day,missionTitle:mission.title,source:"voice_three_item_handoff"});
      try{sessionStorage.setItem("ptiq_pending_inspection_start",JSON.stringify({day:day,at:Date.now(),source:"voice_handoff"}));}catch(e){}
    });
  }
  var continueMission=panel.querySelector("[data-continue-mission]");
  if(continueMission){
    continueMission.addEventListener("click",function(){
      var idx=mission.steps.map(function(s){return s.id;}).indexOf("voice");
      var next=idx>=0?mission.steps[idx+1]:null;
      if(next){scrollToStage(next.id);}
    });
  }
  panel.scrollIntoView({behavior:"smooth",block:"center"});
}
function gradeQuiz(e){
  e.preventDefault();
  var quiz=e.currentTarget;
  var quizStep=mission.steps.filter(function(s){return s.type==="quiz";})[0];
  var answered=0,score=0;
  var missedItems=[];

  quizStep.questions.forEach(function(question,qi){
    var selected=quiz.querySelector('input[name="q'+qi+'"]:checked');
    var correction=q('[data-correction="'+qi+'"]');
    var labels=Array.prototype.slice.call(quiz.querySelectorAll('input[name="q'+qi+'"]')).map(function(input){return input.closest("label");});
    labels.forEach(function(label){if(label){label.classList.remove("is-correct","is-wrong");}});

    if(selected){
      answered++;
      var chosen=Number(selected.value);
      var correct=Number(question[2]);
      var ok=chosen===correct;
      if(ok){score++;}
      labels.forEach(function(label,index){
        if(!label){return;}
        if(index===correct){label.classList.add("is-correct");}
        if(index===chosen&&!ok){label.classList.add("is-wrong");}
      });
      if(correction){
        correction.hidden=ok;
        correction.textContent=ok?"":question[3];
      }
      if(!ok){
        missedItems.push({
          question:String(question[0]||""),
          answer:String((question[1]&&question[1][correct])||""),
          correction:String(question[3]||"")
        });
      }
    }
  });

  var result=q("[data-quiz-result]");
  if(answered<quizStep.questions.length){
    result.textContent="Answer every question before submitting. Then I’ll check the full set with you.";
    result.className="ptiq-mission-quiz__result is-error";
    coachSpeakGlobal("Answer every question first. Then I'll check the full set with you.",{kind:"quiz_incomplete"});
    return;
  }

  state.quizBestScore=Math.max(Number(state.quizBestScore||0),score);
  state.quizAttempts=Number(state.quizAttempts||0)+1;
  writeJSON(missionKey,state);
  trackOnce("analyticsPracticeTestStarted","practice_test_started",{day:day,missionTitle:mission.title,attempt:Number(state.quizAttempts)});
  founderTrack("practice_test_attempted",{day:day,missionTitle:mission.title,score:score,total:quizStep.questions.length,attempt:Number(state.quizAttempts)});

  var total=quizStep.questions.length;
  if(score>=4){
    var perfect=score===total;
    var passWritten="You scored "+score+" of "+total+". "+(perfect?"Excellent work — perfect score. ":"Mission knowledge check passed. ")+coachMissionNextLine();
    var passSpoken="You got "+score+" of "+total+". "+(perfect?"Excellent work. Perfect score. ":"Good job. You passed this knowledge check. ")+coachMissionNextLine();

    result.textContent=passWritten;
    result.className="ptiq-mission-quiz__result is-success";
    state.quiz=true;
    state.quizScore=score;
    writeJSON(missionKey,state);

    trackOnce(
      "analyticsPracticeTestCompleted",
      "practice_test_completed",
      {
        day:day,
        missionTitle:mission.title,
        score:score,
        total:total,
        attempt:Number(state.quizAttempts)
      }
    );

    founderTrack("quiz_results_coached",{
      day:day,
      missionTitle:mission.title,
      score:score,
      total:total,
      passed:true,
      attempt:Number(state.quizAttempts),
      detail:passSpoken
    });

    renderProgress();
    coachSpeakGlobal(passSpoken,{kind:"quiz_pass"});
  }else{
    var firstMiss=missedItems[0]||null;
    var secondMiss=missedItems[1]||null;
    var encouragement=score===3
      ?"You're close. "
      :"This is a lot to learn at once. ";
    var correctionWritten=firstMiss
      ?" Remember: "+firstMiss.answer+". "+firstMiss.correction
      :"";
    var failWritten="You scored "+score+" of "+total+". "+encouragement+"Review the highlighted answers."+correctionWritten+" Try again — you've got this.";
    var failSpoken="You got "+score+" of "+total+". "+encouragement;
    if(firstMiss){
      failSpoken+="Remember: "+firstMiss.answer+". "+firstMiss.correction+" ";
    }
    if(secondMiss&&failSpoken.length<260){
      failSpoken+="Also remember: "+secondMiss.answer+". ";
    }
    failSpoken+="Try again. You've got this.";

    result.textContent=failWritten;
    result.className="ptiq-mission-quiz__result is-error";

    founderTrack("quiz_results_coached",{
      day:day,
      missionTitle:mission.title,
      score:score,
      total:total,
      passed:false,
      attempt:Number(state.quizAttempts),
      missed:missedItems.slice(0,3).map(function(item){return item.question;}),
      detail:failSpoken.slice(0,320)
    });

    coachSpeakGlobal(failSpoken,{kind:"quiz_retry"});
  }
}
function renderProgress(){
  var ids=mission.steps.map(function(s){return s.id;});
  var count=ids.filter(function(id){return state[id]===true;}).length;
  var percent=Math.round(count/ids.length*100);
  var next=firstIncompleteStep();
  var nextId=next?next.id:null;
  setText("[data-step-count]",count+" of "+ids.length+" complete");
  setText("[data-mission-percent]",percent+"%");
  var ring=q("[data-mission-ring]");
  if(ring){
    ring.style.background="radial-gradient(circle at center,#0b1c27 58%,transparent 60%),conic-gradient(var(--cyan) 0 "+percent+"%,rgba(255,255,255,.08) "+percent+"% 100%)";
  }
  ids.forEach(function(id){
    var plan=q('[data-plan-step="'+id+'"]');
    var stage=q('[data-stage="'+id+'"]');
    var done=state[id]===true;
    var active=id===nextId;
    if(plan){
      plan.classList.toggle("is-complete",done);
      plan.classList.toggle("is-active",active);
      var icon=plan.querySelector("i");
      if(icon){icon.textContent=done?"✓":(active?"→":"○");}
    }
    if(stage){
      stage.classList.toggle("is-complete",done);
      stage.classList.toggle("is-active",active);
      stage.classList.toggle("is-locked-step",!done&&!active);
    }
  });
  if(count===ids.length){
    finishMission();
  }else{
    setText("[data-mission-status]",count===0?"Ready to begin":"In progress");
  }
}

/* =========================
   APP REVIEW IQ
   Ask only after earned value. Never interrupt study or Voice Coach.
   Milestones: Day 2, 7, 14, 21. "Not now" uses a 7-day cooldown.
   Once the student taps Rate Pre-Trip IQ, this web layer does not ask again.
   Native iOS should handle action:"request_review" with StoreKit.
   ========================= */
var PTIQ_REVIEW_STATE_KEY="ptiq_review_state_v1";
var PTIQ_REVIEW_MILESTONES={2:true,7:true,14:true,21:true};
var PTIQ_REVIEW_COOLDOWN_MS=7*24*60*60*1000;

function ptiqReviewState(){
  var value=readJSON(PTIQ_REVIEW_STATE_KEY,{});
  return value&&typeof value==="object"?value:{};
}

function ptiqShouldOfferReview(){
  if(!PTIQ_REVIEW_MILESTONES[day]){return false;}
  var review=ptiqReviewState();
  if(review.accepted===true){return false;}
  if(Number(review.lastPromptDay||0)===day){return false;}
  var lastPromptAt=Number(review.lastPromptAt||0);
  if(lastPromptAt>0&&(Date.now()-lastPromptAt)<PTIQ_REVIEW_COOLDOWN_MS){return false;}
  return true;
}

function ptiqReviewPromptHTML(){
  if(!ptiqShouldOfferReview()){return "";}
  return '<div class="ptiq-mission-reward" data-review-prompt style="margin-top:14px">'+
    '<strong>Is Pre-Trip IQ helping you get more confident?</strong>'+
    '<span>If it has helped, a quick App Store rating helps other CDL students find the training too.</span>'+
    '<div class="ptiq-mission-complete__actions" style="margin-top:12px">'+
      '<button class="ptiq-mission-btn ptiq-mission-btn--primary" type="button" data-review-accept>Rate Pre-Trip IQ</button>'+
      '<button class="ptiq-mission-btn ptiq-mission-btn--secondary" type="button" data-review-later>Not Now</button>'+
    '</div>'+
  '</div>';
}

function ptiqRequestNativeReview(source){
  var payload={
    action:"request_review",
    command:"request_review",
    source:source||"mission_complete",
    day:day,
    missionTitle:mission?mission.title:""
  };

  var sent=
    ptiqPostNative("requestReview",payload)||
    ptiqPostNative("review",payload)||
    ptiqPostNative("storeKit",payload)||
    ptiqPostNative("nativeApp",payload);

  try{
    window.dispatchEvent(new CustomEvent("pretrip:request-review",{detail:payload}));
    document.dispatchEvent(new CustomEvent("pretrip:request-review",{detail:payload}));
  }catch(e){}

  if(!sent){
    try{
      window.location.href="pretripiq://review?source="+encodeURIComponent(payload.source)+"&day="+encodeURIComponent(day);
      return true;
    }catch(e){}
  }
  return sent;
}

function ptiqBindReviewPrompt(container){
  if(!container){return;}
  var prompt=container.querySelector("[data-review-prompt]");
  if(!prompt){return;}

  var review=ptiqReviewState();
  review.lastPromptAt=Date.now();
  review.lastPromptDay=day;
  review.promptCount=Number(review.promptCount||0)+1;
  writeJSON(PTIQ_REVIEW_STATE_KEY,review);

  founderTrack("review_prompt",{
    day:day,
    missionTitle:mission?mission.title:"",
    source:"mission_complete",
    promptCount:review.promptCount
  });

  var accept=prompt.querySelector("[data-review-accept]");
  if(accept){
    accept.addEventListener("click",function(){
      var current=ptiqReviewState();
      current.accepted=true;
      current.acceptedAt=Date.now();
      current.acceptedDay=day;
      writeJSON(PTIQ_REVIEW_STATE_KEY,current);

      founderTrack("review_accepted",{
        day:day,
        missionTitle:mission?mission.title:"",
        source:"mission_complete"
      });

      accept.disabled=true;
      accept.textContent="Opening App Store Rating…";
      ptiqRequestNativeReview("mission_complete_day_"+day);

      window.setTimeout(function(){
        prompt.innerHTML='<strong>Thank you.</strong><span>Your rating helps more CDL students discover Pre-Trip IQ.</span>';
      },500);
    });
  }

  var later=prompt.querySelector("[data-review-later]");
  if(later){
    later.addEventListener("click",function(){
      var current=ptiqReviewState();
      current.dismissedAt=Date.now();
      current.dismissedDay=day;
      writeJSON(PTIQ_REVIEW_STATE_KEY,current);
      prompt.remove();
    });
  }
}

function finishMission(){
  if(completedDays.map(Number).indexOf(day)===-1){
    completedDays.push(day);
    completedDays.sort(function(a,b){return Number(a)-Number(b);});
    writeJSON(completedKey,completedDays);
  }
  trackOnce("analyticsMissionCompleted","mission_completed",{
    day:day,
    missionTitle:mission.title,
    quizScore:Number(state.quizScore||0),
    partsScore:Number(state.partsScore||0),
    durationSeconds:founderMissionStartedAt>0
      ?Math.max(1,Math.round((Date.now()-founderMissionStartedAt)/1000))
      :0,
    completedSteps:mission.steps.length,
    totalSteps:mission.steps.length
  });
  trackOnce("analyticsStudyCompleted","study_completed",{day:day,missionTitle:mission.title});
  setText("[data-mission-status]","Complete");
  var p=q("[data-completion-panel]");if(!p){return;}
  var foundationGate=day===4&&!hasPlusAccess();
  var programComplete=day===21;
  var nextHref=programComplete?URLS.dashboard:(foundationGate?"/pages/pre-trip-iq#pretrip-plus":"/pages/pre-trip-mission?day="+(day+1));
  var nextLabel=programComplete
    ?"View My Readiness Dashboard"
    :(foundationGate
      ?"Unlock the Complete System"
      :(day===18
        ?"Start Full Inspection Practice"
        :(day===19
          ?"Continue to Timed Mock Exam"
          :(day===20
            ?"See My Final Readiness"
            :"Continue to Mission "+(day+1)))));

  var nextReason=programComplete
    ?"Your training data is ready. Review strengths, weak areas, and what to practice next."
    :(foundationGate
      ?"You finished the free Foundation. Continue while the sequence is fresh."
      :(day===18
        ?"You have learned the system. Now convert knowledge into a complete inspection."
        :(day===19
          ?"Inspection practice is complete. Test it under time and pressure."
          :(day===20
            ?"Your mock exam is complete. Finish with Readiness IQ."
            :"Keep your momentum. The next mission builds directly on what you just finished."))));

  var badge=programComplete?"21-DAY PROGRAM COMPLETE":(foundationGate?"FOUNDATION COMPLETE":"MISSION COMPLETE");
  var completionCopy=programComplete
    ?"You completed the complete 21-day Pre-Trip IQ curriculum. Use your results to target weak areas, repeat timed practice, and verify exact procedures with your current official CDL manual."
    :mission.summary;
  var totalCompleted=completedDays.map(Number).filter(function(n){return n>=1&&n<=21;}).length;
  var readiness=programComplete
    ?'<div class="ptiq-readiness-summary"><article><small>MISSIONS COMPLETE</small><strong>'+totalCompleted+' / 21</strong></article><article><small>FINAL QUIZ</small><strong>'+Number(state.quizScore||0)+' / 5</strong></article><article><small>STATUS</small><strong>'+(Number(state.quizScore||0)>=4?'READY TO PRACTICE':'REVIEW NEEDED')+'</strong></article></div>'
    :'';
  var progressionBlock=foundationGate?"":progressionCoachHTML("mission_complete");
  var reviewPrompt=ptiqReviewPromptHTML();
  p.innerHTML='<div class="ptiq-mission-complete__badge">✓</div><span class="ptiq-mission-kicker">'+badge+'</span><h2>Day '+day+' finished.</h2><p>'+esc(completionCopy)+'</p><div class="ptiq-mission-reward" style="margin-top:14px"><strong>Best next step</strong><span>'+esc(nextReason)+'</span></div>'+progressionBlock+readiness+'<div class="ptiq-mission-reward"><strong>Professional progress earned</strong><span>Knowledge +'+mission.reward.knowledge+' · Confidence +'+mission.reward.confidence+' · Safety +'+mission.reward.safety+'</span></div>'+reviewPrompt+'<div class="ptiq-mission-complete__scores"><article><small>KNOWLEDGE</small><strong>+'+mission.reward.knowledge+'</strong></article><article><small>CONFIDENCE</small><strong>+'+mission.reward.confidence+'</strong></article><article><small>PROGRAM</small><strong>'+day+' / 21</strong></article><article><small>NEXT</small><strong>'+esc(mission.reward.next)+'</strong></article></div><div class="ptiq-mission-complete__actions"><a class="ptiq-mission-btn ptiq-mission-btn--primary" href="'+nextHref+'">'+nextLabel+' <span>→</span></a><a class="ptiq-mission-btn ptiq-mission-btn--secondary" href="'+URLS.dashboard+'">Return to Dashboard</a></div>';
  if(!foundationGate){bindProgressionCoach(p,"mission_complete");}
  ptiqBindReviewPrompt(p);
  p.hidden=false;

  if(foundationGate){
    ptiqTrackSessionOnce(
      "upgrade_viewed_foundation_complete",
      "upgrade_viewed",
      {
        day:day,
        source:"foundation_day_4_complete",
        gate:"foundation_complete",
        plans:["monthly","yearly"]
      }
    );

    var unlockButton=p.querySelector(".ptiq-mission-complete__actions .ptiq-mission-btn--primary");
    if(unlockButton){
      unlockButton.setAttribute("href","#");
      unlockButton.addEventListener("click",function(event){
        event.preventDefault();
        ptiqOpenPlus("monthly","foundation_day_4_complete");
      });
    }
  }
}
var start=q("[data-start-mission]");
if(start){
  start.addEventListener("click",function(){
    if(!founderStudyStartedThisPage){
      founderStudyStartedThisPage=true;
      founderMissionStartedAt=Date.now();
      founderTrack("mission_started",{
        day:day,
        missionTitle:mission?mission.title:"",
        source:"start_button",
        progressionVersion:PTIQ_PROGRESS_VERSION
      });
      founderTrack("study_started",{
        day:day,
        missionTitle:mission?mission.title:"",
        source:"start_button"
      });
      if(day>=19&&day<=20){
        founderTrack("inspection_started",{
          day:day,
          missionTitle:mission?mission.title:"",
          source:"start_button"
        });
      }
      if(day===21){
        founderTrack("readiness_opened",{
          day:day,
          missionTitle:mission?mission.title:"",
          source:"final_mission_start"
        });
      }
    }
    var next=firstIncompleteStep();
    if(next){
      scrollToStage(next.id);
    }else if(isComplete()){
      var panel=q("[data-completion-panel]");
      if(panel){
        panel.scrollIntoView({behavior:"smooth",block:"start"});
      }
    }
  });
}

/*
  Record every live mission page visit in the cloud.
  This deliberately does not use the old persistent trackOnce flags,
  because those flags may already be set from activity recorded before
  cloud ingestion was connected.
*/
ptiqTrackStudentOpenedOncePerDay({
  day:day,
  missionTitle:mission?mission.title:"",
  locked:locked===true,
  completed:isComplete(),
  source:"mission_page_load",
  definition:"unique_device_day"
});

render();
})();